<template>
  <section class="section">
    <div class="section-body">
      <div class="card" v-if="!isEdit && mode != 'copy' && mode != 'edit'">
        <div class="card-header">
          <v-icon color="pink">search</v-icon>
          <h4>{{ $t("messages.general.searchShowInfo") }}</h4>
        </div>
        <div class="card-body">
          <v-card width="100%">
            <v-row>
              <v-col
                cols="10"
                style="padding-top: 0; padding-bottom: 0; padding-right: 0;text-align: right;"
              >
                <p style="color: red; margin: 0">*</p>
              </v-col>
              <v-col
                style="padding-top: 0; padding-bottom: 0; padding-right: 5px;"
              >
                <p style="margin: 0">{{ $t("messages.general.reqFields") }}</p>
              </v-col>
            </v-row>
          </v-card>
          <form>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label
                      >{{ $t("messages.general.academicYear") }}
                      <code style="background: none; box-shadow: none;"
                        >*</code
                      ></label
                    >
                  </div>
                  <div class="col no-margin-padding">
                    <AcademicYear
                      :onChanged="onSelYearChanged"
                      :selectedVal="selYear"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label
                      >{{ $t("messages.general.semester") }}
                      <code style="background: none; box-shadow: none;"
                        >*</code
                      ></label
                    >
                  </div>
                  <div class="col no-margin-padding">
                    <Semester
                      :onChanged="onSelSemesterChanged"
                      :selectedVal="selSemester"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label
                      >{{ $t("messages.general.educationLvl") }}
                      <code style="background: none; box-shadow: none;"
                        >*</code
                      ></label
                    >
                  </div>
                  <div class="col no-margin-padding">
                    <Level
                      :onChanged="onSelLvlChanged"
                      :selectedVal="selLvl"
                      :disabled="false"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>{{ $t("messages.general.classCode") }}</label>
                  </div>
                  <div class="col no-margin-padding">
                    <div class="form-row">
                      <div
                        class="col no-margin-padding"
                        style="flex: 0 0 16em; padding-top: 0; padding-left: 5px; padding-right: 5px; padding-bottom: 0;"
                      >
                        <div class="form-group" style="margin-bottom: 0;">
                          <div class="input-group">
                            <div class="form-inline">
                              <div class="input-group-append">
                                <input
                                  type="text"
                                  class="form-control col mr-2"
                                  style="margin-right: 0px !important"
                                  v-model="courseCode"
                                  @keypress="handleSearchClsKey($event)"
                                />
                                <button
                                  type="button"
                                  class="btn btn-temp btn-lg"
                                  @click="handleSearchCls()"
                                >
                                  <i class="fas fa-search"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="col no-margin-padding"
                        style="padding-left: 5px; padding-top: 0; padding-right: 0; padding-bottom: 0;"
                      >
                        <div class="form-group" style="margin-bottom: 0;">
                          <div class="form-inline">
                            <input
                              type="text"
                              class="form-control col mr-2"
                              style="margin-right: 0px !important"
                              disabled
                              v-model="courseName"
                            />
                            <button
                              type="button"
                              class="btn btn-danger btn-lg"
                              @click="handleClrCourse()"
                            >
                              <i class="fas fa-trash"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>{{ $t("messages.general.section") }} </label>
                  </div>
                  <div class="col no-margin-padding">
                    <div>
                      <select
                        class="form-control"
                        @change="onSelSectionChanged($event)"
                      >
                        <option :selected="selSection == '00'" value="00"
                          >---{{
                            $t("messages.general.notSpecified")
                          }}---</option
                        >
                        <option
                          v-for="(item, index) in sections"
                          :key="index"
                          :value="item.SECTION_TEXT"
                          :selected="selSection == item.SECTION_TEXT"
                        >
                          {{ item.SECTION_TEXT }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="form-row flex-column justify-content-center align-items-center mt-5"
            >
              <div class="form-group">
                <div class="form-inline">
                  <button
                    type="button"
                    class="btn btn-primary btn-lg"
                    @click="handleSearchConfirmResult()"
                  >
                    {{ $t("messages.general.search") }}</button
                  >&nbsp;&nbsp;&nbsp;
                  <button
                    type="button"
                    class="btn btn-primary btn-lg"
                    @click="handleClearScreen()"
                  >
                    {{ $t("messages.general.clearScreen") }}</button
                  >&nbsp;&nbsp;&nbsp;
                  <button
                    type="button"
                    class="btn btn-primary btn-lg"
                    @click="handleAssByFac()"
                  >
                    {{ $t("messages.general.assigningByFaculty") }}</button
                  >&nbsp;&nbsp;&nbsp;
                </div>
              </div>
            </div>
          </form>
          <v-card>
            <b-table
              bordered
              hover
              small
              responsive
              caption-top
              class="table table-striped text-center"
              :sort-by.sync="bTable.sortBy"
              :sort-desc.sync="bTable.sortDesc"
              :items="bTable.items"
              :fields="bTable.fields"
              :per-page="perPage"
              :current-page="currentPage"
            >
              <template slot="table-caption">
                <div class="float-left">
                  <b class="mr-2">{{
                    $t("messages.general.table.paginationinfo")
                  }}</b>
                  <b-form-select
                    v-model="perPage"
                    :options="perPageOptions"
                    size="sm"
                    style="width:70px"
                  />
                </div>
                <b-pagination
                  class="float-right"
                  size="sm"
                  :total-rows="bTable.items.length"
                  v-model="currentPage"
                  :per-page="perPage"
                />
                <div
                  v-if="bTable.items.length > 0"
                  class="float-right data-table-page-info"
                >
                  {{
                    Number(
                      currentPage > 1
                        ? (currentPage - 1) * perPage + 1
                        : currentPage
                    ).toLocaleString()
                  }}
                  -
                  {{
                    Number(
                      currentPage * perPage > bTable.items.length
                        ? bTable.items.length
                        : currentPage * perPage
                    ).toLocaleString()
                  }}
                  {{ $t("messages.general.fromRecords") }}
                  {{ Number(bTable.items.length).toLocaleString() }}
                </div>
                <div
                  v-if="bTable.items.length <= 0"
                  class="float-right data-table-page-info"
                >
                  0 - 0
                  {{ $t("messages.general.fromRecords") }}
                  {{ Number(bTable.items.length).toLocaleString() }}
                </div>
              </template>
              <template v-slot:cell(action)="data">
                <v-btn text icon @click="goTo(data.item, data.index, 'edit')">
                  <v-icon @click="goTo(data.item, data.index, 'edit')"
                    >edit</v-icon
                  >
                </v-btn>
              </template>

              <template slot="table-caption">
                <div
                  style="position: absolute; bottom: -65px; width: 100%; height: 65px; padding-top: 10px; border-color: #fff; box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);"
                >
                  <div class="float-left">
                    <b class="mr-2">{{
                      $t("messages.general.table.paginationinfo")
                    }}</b>
                    <b-form-select
                      v-model="perPage"
                      :options="perPageOptions"
                      size="sm"
                      style="width:70px"
                    />
                  </div>
                  <b-pagination
                    class="float-right"
                    size="sm"
                    :total-rows="bTable.items.length"
                    v-model="currentPage"
                    :per-page="perPage"
                    style="padding-top: 10px"
                  />
                  <div
                    v-if="bTable.items.length > 0"
                    class="float-right data-table-page-info"
                    style="padding-top: 14px"
                  >
                    {{
                      Number(
                        currentPage > 1
                          ? (currentPage - 1) * perPage + 1
                          : currentPage
                      ).toLocaleString()
                    }}
                    -
                    {{
                      Number(
                        currentPage * perPage > bTable.items.length
                          ? bTable.items.length
                          : currentPage * perPage
                      ).toLocaleString()
                    }}
                    {{ $t("messages.general.fromRecords") }}
                    {{ Number(bTable.items.length).toLocaleString() }}
                  </div>
                  <div
                    v-if="bTable.items.length <= 0"
                    class="float-right data-table-page-info"
                    style="padding-top: 14px"
                  >
                    0 - 0
                    {{ $t("messages.general.fromRecords") }}
                    {{ Number(bTable.items.length).toLocaleString() }}
                  </div>
                </div>
              </template>
            </b-table>
          </v-card>
        </div>
      </div>
      <div class="card" v-if="!isEdit && mode == 'copy'">
        <div class="card-header">
          <v-icon color="pink">search</v-icon>
          <h4>{{ $t("messages.general.assigningByFaculty") }}</h4>
        </div>
        <div class="card-body">
          <v-card width="100%">
            <v-row>
              <v-col
                cols="10"
                style="padding-top: 0; padding-bottom: 0; padding-right: 0;text-align: right;"
              >
                <p style="color: red; margin: 0">*</p>
              </v-col>
              <v-col
                style="padding-top: 0; padding-bottom: 0; padding-right: 5px;"
              >
                <p style="margin: 0">{{ $t("messages.general.reqFields") }}</p>
              </v-col>
            </v-row>
          </v-card>
          <form>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label
                      >{{ $t("messages.general.academicYear") }}
                      <code style="background: none; box-shadow: none;"
                        >*</code
                      ></label
                    >
                  </div>
                  <div class="col no-margin-padding">
                    <AcademicYear
                      :onChanged="onSelYearChangedFac"
                      :selectedVal="selYearFac"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label
                      >{{ $t("messages.general.semester") }}
                      <code style="background: none; box-shadow: none;"
                        >*</code
                      ></label
                    >
                  </div>
                  <div class="col no-margin-padding">
                    <Semester
                      :onChanged="onSelSemesterChangedFac"
                      :selectedVal="selSemesterFac"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label
                      >{{ $t("messages.general.educationLvl") }}
                      <code style="background: none; box-shadow: none;"
                        >*</code
                      ></label
                    >
                  </div>
                  <div class="col no-margin-padding">
                    <Level
                      :onChanged="onSelLvlChangedFac"
                      :selectedVal="selLvlFac"
                      :disabled="false"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>{{ $t("messages.general.faculty") }}</label>
                  </div>
                  <div class="col no-margin-padding">
                    <Faculty
                      :onChanged="onSelFacultyProgramChangedFac"
                      :selectedVal="selFacultyProgramFac"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>{{ $t("messages.general.department") }}</label>
                  </div>
                  <div class="col no-margin-padding">
                    <Department
                      :onChanged="onSelDepartmentProgramChangedFac"
                      :facultyid="selFacultyProgramFac"
                      :selectedVal="selDepartmentProgramFac"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div
              class="form-row flex-column justify-content-center align-items-center mt-5"
            >
              <div class="form-group">
                <div class="form-inline">
                  <button
                    type="button"
                    class="btn btn-primary btn-lg"
                    @click="handleSearchConfirmResultAssignFac()"
                  >
                    {{ $t("messages.general.search") }}</button
                  >&nbsp;&nbsp;&nbsp;
                  <button
                    type="button"
                    class="btn btn-primary btn-lg"
                    @click="handleClearScreenAssignFac()"
                  >
                    {{ $t("messages.general.clearScreen") }}</button
                  >&nbsp;&nbsp;&nbsp;
                  <button
                    type="button"
                    class="btn btn-primary btn-lg"
                    @click="goBackFromByfac()"
                  >
                    {{ $t("messages.general.backhome") }}</button
                  >&nbsp;&nbsp;&nbsp;
                </div>
              </div>
            </div>
          </form>
          <v-card>
            <b-table
              bordered
              hover
              small
              responsive
              caption-top
              class="table table-striped text-center"
              :sort-by.sync="bTableAssignByFaculty.sortBy"
              :sort-desc.sync="bTableAssignByFaculty.sortDesc"
              :items="bTableAssignByFaculty.items"
              :fields="bTableAssignByFaculty.fields"
              :per-page="perPage"
              :current-page="currentPage"
            >
              <template slot="table-caption">
                <div class="float-left">
                  <b class="mr-2">{{
                    $t("messages.general.table.paginationinfo")
                  }}</b>
                  <b-form-select
                    v-model="perPage"
                    :options="perPageOptions"
                    size="sm"
                    style="width:70px"
                  />
                </div>
                <b-pagination
                  class="float-right"
                  size="sm"
                  :total-rows="bTableAssignByFaculty.items.length"
                  v-model="currentPage"
                  :per-page="perPage"
                />
                <div
                  v-if="bTableAssignByFaculty.items.length > 0"
                  class="float-right data-table-page-info"
                >
                  {{
                    Number(
                      currentPage > 1
                        ? (currentPage - 1) * perPage + 1
                        : currentPage
                    ).toLocaleString()
                  }}
                  -
                  {{
                    Number(
                      currentPage * perPage > bTableAssignByFaculty.items.length
                        ? bTableAssignByFaculty.items.length
                        : currentPage * perPage
                    ).toLocaleString()
                  }}
                  {{ $t("messages.general.fromRecords") }}
                  {{
                    Number(bTableAssignByFaculty.items.length).toLocaleString()
                  }}
                </div>
                <div
                  v-if="bTableAssignByFaculty.items.length <= 0"
                  class="float-right data-table-page-info"
                >
                  0 - 0
                  {{ $t("messages.general.fromRecords") }}
                  {{
                    Number(bTableAssignByFaculty.items.length).toLocaleString()
                  }}
                </div>
              </template>

              <template slot="table-caption">
                <div
                  style="position: absolute; bottom: -65px; width: 100%; height: 65px; padding-top: 10px; border-color: #fff; box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);"
                >
                  <div class="float-left">
                    <b class="mr-2">{{
                      $t("messages.general.table.paginationinfo")
                    }}</b>
                    <b-form-select
                      v-model="perPage"
                      :options="perPageOptions"
                      size="sm"
                      style="width:70px"
                    />
                  </div>
                  <b-pagination
                    class="float-right"
                    size="sm"
                    :total-rows="bTableAssignByFaculty.items.length"
                    v-model="currentPage"
                    :per-page="perPage"
                    style="padding-top: 10px"
                  />
                  <div
                    v-if="bTableAssignByFaculty.items.length > 0"
                    class="float-right data-table-page-info"
                    style="padding-top: 14px"
                  >
                    {{
                      Number(
                        currentPage > 1
                          ? (currentPage - 1) * perPage + 1
                          : currentPage
                      ).toLocaleString()
                    }}
                    -
                    {{
                      Number(
                        currentPage * perPage >
                          bTableAssignByFaculty.items.length
                          ? bTableAssignByFaculty.items.length
                          : currentPage * perPage
                      ).toLocaleString()
                    }}
                    {{ $t("messages.general.fromRecords") }}
                    {{
                      Number(
                        bTableAssignByFaculty.items.length
                      ).toLocaleString()
                    }}
                  </div>
                  <div
                    v-if="bTableAssignByFaculty.items.length <= 0"
                    class="float-right data-table-page-info"
                    style="padding-top: 14px"
                  >
                    0 - 0
                    {{ $t("messages.general.fromRecords") }}
                    {{
                      Number(
                        bTableAssignByFaculty.items.length
                      ).toLocaleString()
                    }}
                  </div>
                </div>
              </template>
              <template v-slot:head(selCheckINSTRUCTORSTATUS)="">
                <label>{{ $t("messages.general.teachers") }}</label
                ><br />
                <input
                  type="checkbox"
                  id="chkAllInstructor"
                  @change="handleChkAllInstructor($event)"
                  :checked="
                    bTableAssignByFaculty.items.length > 0 &&
                      bTableAssignByFaculty.items.length ==
                        instructorList.length
                  "
                />
              </template>
              <template v-slot:cell(selCheckINSTRUCTORSTATUS)="data">
                <input
                  type="checkbox"
                  id="chkInstructor"
                  @change="handleChkInstructor($event, data)"
                  :checked="data.item.selCheckINSTRUCTORSTATUS"
                />
              </template>

              <template v-slot:head(selCheckCOCOURSESTATUS)="">
                <label>{{ $t("messages.general.coordinatorforCourse") }}</label
                ><br />
                <input
                  type="checkbox"
                  id="chkAllCoCourse"
                  @change="handleChkAllCoCourse($event, 3)"
                  :checked="
                    bTableAssignByFaculty.items.length > 0 &&
                      bTableAssignByFaculty.items.length == coCourseList.length
                  "
                />
              </template>
              <template v-slot:cell(selCheckCOCOURSESTATUS)="data">
                <input
                  type="checkbox"
                  id="chkCoCourse"
                  @change="handleChkCoCourse($event, data, 3)"
                  :checked="data.item.selCheckCOCOURSESTATUS"
                />
              </template>

              <template v-slot:head(selCheckTASTATUS)="">
                <label>{{ $t("messages.general.assistantForTeach") }}</label
                ><br />
                <input
                  type="checkbox"
                  id="chkAllTa"
                  @change="handleChkAllTa($event, 2)"
                  :checked="
                    bTableAssignByFaculty.items.length > 0 &&
                      bTableAssignByFaculty.items.length == taList.length
                  "
                />
              </template>
              <template v-slot:cell(selCheckTASTATUS)="data">
                <input
                  type="checkbox"
                  id="chkTa"
                  @change="handleChkTa($event, data, 2)"
                  :checked="data.item.selCheckTASTATUS"
                />
              </template>

              <template v-slot:head(selCheckCOEXAMSTATUS)="">
                <label>{{ $t("messages.general.coorSched") }}</label
                ><br />
                <input
                  type="checkbox"
                  id="chkAllCoExam"
                  @change="handleChkAllCoExam($event, 4)"
                  :checked="
                    bTableAssignByFaculty.items.length > 0 &&
                      bTableAssignByFaculty.items.length == coExamList.length
                  "
                />
              </template>
              <template v-slot:cell(selCheckCOEXAMSTATUS)="data">
                <input
                  type="checkbox"
                  id="chkCoExam"
                  @change="handleChkCoExam($event, data, 4)"
                  :checked="data.item.selCheckCOEXAMSTATUS"
                />
              </template>
            </b-table>
          </v-card>
        </div>
      </div>
      <div class="card" v-if="isEdit && mode == 'edit'">
        <div class="card-header">
          <v-icon color="pink">edit</v-icon>
          <h4>{{ $t("messages.general.manageData") }}</h4>
        </div>
        <v-card width="100%">
          <v-row>
            <v-col
              cols="10"
              style="padding-top: 0; padding-bottom: 0; padding-right: 0;text-align: right;"
            >
              <p style="color: red; margin: 0">*</p>
            </v-col>
            <v-col
              style="padding-top: 0; padding-bottom: 0; padding-right: 5px;"
            >
              <p style="margin: 0">{{ $t("messages.general.reqFields") }}</p>
            </v-col>
          </v-row>
        </v-card>
        <form>
          <div class="information-block">
            <div class="row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 16em;">
                    <div>{{ $t("messages.general.academicYear") }}</div>
                  </div>
                  <div class="col no-margin-padding">
                    <div>{{ selectedDetail.ACADYEAR }}</div>
                  </div>
                  <div class="col no-margin-padding">
                    <div></div>
                  </div>
                  <div class="col no-margin-padding">
                    <div></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 16em;">
                    <div>{{ $t("messages.general.semester") }}</div>
                  </div>
                  <div class="col no-margin-padding">
                    <div>{{ selectedDetail.SEMESTER }}</div>
                  </div>
                  <div class="col no-margin-padding">
                    <div></div>
                  </div>
                  <div class="col no-margin-padding">
                    <div></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 16em;">
                    <div>{{ $t("messages.general.educationLvl") }}</div>
                  </div>
                  <div class="col no-margin-padding">
                    <div>{{ selectedDetail.LEVELNAME }}</div>
                  </div>
                  <div class="col no-margin-padding">
                    <div></div>
                  </div>
                  <div class="col no-margin-padding">
                    <div></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 16em;">
                    <div>{{ $t("messages.general.classId") }}</div>
                  </div>
                  <div class="col no-margin-padding">
                    <div>{{ selectedDetail.COURSECODE }}</div>
                  </div>
                  <div class="col no-margin-padding">
                    <div></div>
                  </div>
                  <div class="col no-margin-padding">
                    <div></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 16em;">
                    <div>{{ $t("messages.general.className") }}</div>
                  </div>
                  <div class="col no-margin-padding">
                    <div>{{ selectedDetail.COURSENAME }}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 16em;">
                    <div>{{ $t("messages.general.section") }}</div>
                  </div>
                  <div class="col no-margin-padding">
                    <div>{{ selectedDetail.SECTION }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="form-row flex-column justify-content-center align-items-center mt-5"
          >
            <div class="form-group">
              <div class="form-inline">
                <button
                  type="button"
                  class="btn btn-primary btn-lg"
                  @click="copyAuthorization()"
                >
                  {{ $t("messages.general.copyAuthor") }}</button
                >&nbsp;&nbsp;&nbsp;
                <button
                  type="button"
                  class="btn btn-primary btn-lg"
                  @click="goBack()"
                >
                  {{ $t("messages.general.backhome") }}</button
                >&nbsp;&nbsp;&nbsp;
              </div>
            </div>
          </div>
          <v-tabs v-model="selTab">
            <v-tab v-if="listTypeCode1.length > 0" href="#tab-1">{{
              $t("messages.general.teachers")
            }}</v-tab>
            <v-tab v-if="listTypeCode3.length > 0" href="#tab-3">{{
              $t("messages.general.coordinatorforCourse")
            }}</v-tab>
            <v-tab v-if="listTypeCode2.length > 0" href="#tab-2">{{
              $t("messages.general.assistantForTeach")
            }}</v-tab>
            <v-tab v-if="listTypeCode4.length > 0" href="#tab-4">{{
              $t("messages.general.coorSched")
            }}</v-tab>
            <v-tab-item value="tab-1">
              <v-card flat>
                <v-card-text>
                  <v-sheet>
                    <v-card>
                      <b-table
                        bordered
                        hover
                        small
                        responsive
                        caption-top
                        class="table table-striped text-center"
                        :sort-by.sync="bTableTeachers.sortBy"
                        :sort-desc.sync="bTableTeachers.sortDesc"
                        :items="bTableTeachers.items"
                        :fields="bTableTeachers.fields"
                        :per-page="perPage"
                        :current-page="currentPage"
                      >
                        <template slot="table-caption">
                          <div class="float-left">
                            <b class="mr-2">{{
                              $t("messages.general.table.paginationinfo")
                            }}</b>
                            <b-form-select
                              v-model="perPage"
                              :options="perPageOptions"
                              size="sm"
                              style="width:70px"
                            />
                          </div>
                          <b-pagination
                            class="float-right"
                            size="sm"
                            :total-rows="bTableTeachers.items.length"
                            v-model="currentPage"
                            :per-page="perPage"
                          />
                          <div
                            v-if="bTableTeachers.items.length > 0"
                            class="float-right data-table-page-info"
                          >
                            {{
                              Number(
                                currentPage > 1
                                  ? (currentPage - 1) * perPage + 1
                                  : currentPage
                              ).toLocaleString()
                            }}
                            -
                            {{
                              Number(
                                currentPage * perPage >
                                  bTableTeachers.items.length
                                  ? bTableTeachers.items.length
                                  : currentPage * perPage
                              ).toLocaleString()
                            }}
                            {{ $t("messages.general.fromRecords") }}
                            {{
                              Number(
                                bTableTeachers.items.length
                              ).toLocaleString()
                            }}
                          </div>
                          <div
                            v-if="bTableTeachers.items.length <= 0"
                            class="float-right data-table-page-info"
                          >
                            0 - 0
                            {{ $t("messages.general.fromRecords") }}
                            {{
                              Number(
                                bTableTeachers.items.length
                              ).toLocaleString()
                            }}
                          </div>
                        </template>
                        <template v-slot:head(selCheckCANMANAGE)="">
                          <label>{{
                            $t("messages.general.editReceiveAmount")
                          }}</label
                          ><br />
                          <input
                            type="checkbox"
                            id="chkAll"
                            @change="handleChkAllT($event, 1)"
                            :checked="
                              bTableTeachers.items.length > 0 &&
                                bTableTeachers.items.length ==
                                  classTearcherist.length
                            "
                          />
                        </template>
                        <template v-slot:cell(selCheckCANMANAGE)="data">
                          <input
                            type="checkbox"
                            id="chk"
                            @change="handleChkT($event, data, 1)"
                            :checked="data.item.selCheckCANMANAGE"
                          />
                        </template>

                        <template v-slot:head(selCheckCANRESERVE)="">
                          <label>{{
                            $t("messages.general.reserveAseat")
                          }}</label
                          ><br />
                          <input
                            type="checkbox"
                            id="chkAllReserve"
                            @change="handleChkAllTReserve($event, 1)"
                            :checked="
                              bTableTeachers.items.length > 0 &&
                                bTableTeachers.items.length ==
                                  classTearcheristReserve.length
                            "
                          />
                        </template>
                        <template v-slot:cell(selCheckCANRESERVE)="data">
                          <input
                            type="checkbox"
                            id="chkReserve"
                            @change="handleChkTReserve($event, data, 1)"
                            :checked="data.item.selCheckCANRESERVE"
                          />
                        </template>

                        <template v-slot:head(selCheckCANMOVE)="">
                          <label>{{ $t("messages.general.moveDurCls") }}</label
                          ><br />
                          <input
                            type="checkbox"
                            id="chkAllMove"
                            @change="handleChkAllTMove($event, 1)"
                            :checked="
                              bTableTeachers.items.length > 0 &&
                                bTableTeachers.items.length ==
                                  classTearcheristMove.length
                            "
                          />
                        </template>
                        <template v-slot:cell(selCheckCANMOVE)="data">
                          <input
                            type="checkbox"
                            id="chkMove"
                            @change="handleChkTMove($event, data, 1)"
                            :checked="data.item.selCheckCANMOVE"
                          />
                        </template>

                        <template v-slot:head(selCheckCANADJUST)="">
                          <label>{{
                            $t("messages.general.classStatusCOP")
                          }}</label
                          ><br />
                          <input
                            type="checkbox"
                            id="chkAllCop"
                            @change="handleChkAllTAdjust($event, 1)"
                            :checked="
                              bTableTeachers.items.length > 0 &&
                                bTableTeachers.items.length ==
                                  classTearcheristCop.length
                            "
                          />
                        </template>
                        <template v-slot:cell(selCheckCANADJUST)="data">
                          <input
                            type="checkbox"
                            id="chkCop"
                            @change="handleChkTAdjust($event, data, 1)"
                            :checked="data.item.selCheckCANADJUST"
                          />
                        </template>

                        <template v-slot:head(selCheckCANCONFIRM)="">
                          <label>{{ $t("messages.general.confirmReg") }}</label
                          ><br />
                          <input
                            type="checkbox"
                            id="chkAllConfirm"
                            @change="handleChkAllTConfirm($event, 1)"
                            :checked="
                              bTableTeachers.items.length > 0 &&
                                bTableTeachers.items.length ==
                                  classTearcheristConfirm.length
                            "
                          />
                        </template>
                        <template v-slot:cell(selCheckCANCONFIRM)="data">
                          <input
                            type="checkbox"
                            id="chkConfirm"
                            @change="handleChkTConfirm($event, data, 1)"
                            :checked="data.item.selCheckCANCONFIRM"
                          />
                        </template>

                        <template slot="table-caption">
                          <div
                            style="position: absolute; bottom: -65px; width: 100%; height: 65px; padding-top: 10px; border-color: #fff; box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);"
                          >
                            <div class="float-left">
                              <b class="mr-2">{{
                                $t("messages.general.table.paginationinfo")
                              }}</b>
                              <b-form-select
                                v-model="perPage"
                                :options="perPageOptions"
                                size="sm"
                                style="width:70px"
                              />
                            </div>
                            <b-pagination
                              class="float-right"
                              size="sm"
                              :total-rows="bTableTeachers.items.length"
                              v-model="currentPage"
                              :per-page="perPage"
                              style="padding-top: 10px"
                            />
                            <div
                              v-if="bTableTeachers.items.length > 0"
                              class="float-right data-table-page-info"
                              style="padding-top: 14px"
                            >
                              {{
                                Number(
                                  currentPage > 1
                                    ? (currentPage - 1) * perPage + 1
                                    : currentPage
                                ).toLocaleString()
                              }}
                              -
                              {{
                                Number(
                                  currentPage * perPage >
                                    bTableTeachers.items.length
                                    ? bTableTeachers.items.length
                                    : currentPage * perPage
                                ).toLocaleString()
                              }}
                              {{ $t("messages.general.fromRecords") }}
                              {{
                                Number(
                                  bTableTeachers.items.length
                                ).toLocaleString()
                              }}
                            </div>
                            <div
                              v-if="bTableTeachers.items.length <= 0"
                              class="float-right data-table-page-info"
                              style="padding-top: 14px"
                            >
                              0 - 0
                              {{ $t("messages.general.fromRecords") }}
                              {{
                                Number(
                                  bTableTeachers.items.length
                                ).toLocaleString()
                              }}
                            </div>
                          </div>
                        </template>
                      </b-table>
                    </v-card>
                  </v-sheet>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item value="tab-3">
              <v-card flat>
                <v-card-text>
                  <v-sheet>
                    <v-card>
                      <b-table
                        bordered
                        hover
                        small
                        responsive
                        caption-top
                        class="table table-striped text-center"
                        :sort-by.sync="bTableCOs.sortBy"
                        :sort-desc.sync="bTableCOs.sortDesc"
                        :items="bTableCOs.items"
                        :fields="bTableCOs.fields"
                        :per-page="perPage"
                        :current-page="currentPage"
                      >
                        <template slot="table-caption">
                          <div class="float-left">
                            <b class="mr-2">{{
                              $t("messages.general.table.paginationinfo")
                            }}</b>
                            <b-form-select
                              v-model="perPage"
                              :options="perPageOptions"
                              size="sm"
                              style="width:70px"
                            />
                          </div>
                          <b-pagination
                            class="float-right"
                            size="sm"
                            :total-rows="bTableCOs.items.length"
                            v-model="currentPage"
                            :per-page="perPage"
                          />
                          <div
                            v-if="bTableCOs.items.length > 0"
                            class="float-right data-table-page-info"
                          >
                            {{
                              Number(
                                currentPage > 1
                                  ? (currentPage - 1) * perPage + 1
                                  : currentPage
                              ).toLocaleString()
                            }}
                            -
                            {{
                              Number(
                                currentPage * perPage > bTableCOs.items.length
                                  ? bTableCOs.items.length
                                  : currentPage * perPage
                              ).toLocaleString()
                            }}
                            {{ $t("messages.general.fromRecords") }}
                            {{
                              Number(bTableCOs.items.length).toLocaleString()
                            }}
                          </div>
                          <div
                            v-if="bTableCOs.items.length <= 0"
                            class="float-right data-table-page-info"
                          >
                            0 - 0
                            {{ $t("messages.general.fromRecords") }}
                            {{
                              Number(bTableCOs.items.length).toLocaleString()
                            }}
                          </div>
                        </template>
                        <template v-slot:head(selCheckCANMANAGE)="">
                          <label>{{
                            $t("messages.general.editReceiveAmount")
                          }}</label
                          ><br />
                          <input
                            type="checkbox"
                            id="chkAll"
                            @change="handleChkAllT($event, 3)"
                            :checked="
                              bTableCOs.items.length > 0 &&
                                bTableCOs.items.length ==
                                  classTearcherist.length
                            "
                          />
                        </template>
                        <template v-slot:cell(selCheckCANMANAGE)="data">
                          <input
                            type="checkbox"
                            id="chk"
                            @change="handleChkT($event, data, 3)"
                            :checked="data.item.selCheckCANMANAGE"
                          />
                        </template>

                        <template v-slot:head(selCheckCANRESERVE)="">
                          <label>{{
                            $t("messages.general.reserveAseat")
                          }}</label
                          ><br />
                          <input
                            type="checkbox"
                            id="chkAllReserve"
                            @change="handleChkAllTReserve($event, 3)"
                            :checked="
                              bTableCOs.items.length > 0 &&
                                bTableCOs.items.length ==
                                  classTearcheristReserve.length
                            "
                          />
                        </template>
                        <template v-slot:cell(selCheckCANRESERVE)="data">
                          <input
                            type="checkbox"
                            id="chkReserve"
                            @change="handleChkTReserve($event, data, 3)"
                            :checked="data.item.selCheckCANRESERVE"
                          />
                        </template>

                        <template v-slot:head(selCheckCANMOVE)="">
                          <label>{{ $t("messages.general.moveDurCls") }}</label
                          ><br />
                          <input
                            type="checkbox"
                            id="chkAllMove"
                            @change="handleChkAllTMove($event, 3)"
                            :checked="
                              bTableCOs.items.length > 0 &&
                                bTableCOs.items.length ==
                                  classTearcheristMove.length
                            "
                          />
                        </template>
                        <template v-slot:cell(selCheckCANMOVE)="data">
                          <input
                            type="checkbox"
                            id="chkMove"
                            @change="handleChkTMove($event, data, 3)"
                            :checked="data.item.selCheckCANMOVE"
                          />
                        </template>

                        <template v-slot:head(selCheckCANADJUST)="">
                          <label>{{
                            $t("messages.general.classStatusCOP")
                          }}</label
                          ><br />
                          <input
                            type="checkbox"
                            id="chkAllCop"
                            @change="handleChkAllTAdjust($event, 3)"
                            :checked="
                              bTableCOs.items.length > 0 &&
                                bTableCOs.items.length ==
                                  classTearcheristCop.length
                            "
                          />
                        </template>
                        <template v-slot:cell(selCheckCANADJUST)="data">
                          <input
                            type="checkbox"
                            id="chkCop"
                            @change="handleChkTAdjust($event, data, 3)"
                            :checked="data.item.selCheckCANADJUST"
                          />
                        </template>

                        <template v-slot:head(selCheckCANCONFIRM)="">
                          <label>{{ $t("messages.general.confirmReg") }}</label
                          ><br />
                          <input
                            type="checkbox"
                            id="chkAllConfirm"
                            @change="handleChkAllTConfirm($event, 3)"
                            :checked="
                              bTableCOs.items.length > 0 &&
                                bTableCOs.items.length ==
                                  classTearcheristConfirm.length
                            "
                          />
                        </template>
                        <template v-slot:cell(selCheckCANCONFIRM)="data">
                          <input
                            type="checkbox"
                            id="chkConfirm"
                            @change="handleChkTConfirm($event, data, 3)"
                            :checked="data.item.selCheckCANCONFIRM"
                          />
                        </template>

                        <template slot="table-caption">
                          <div
                            style="position: absolute; bottom: -65px; width: 100%; height: 65px; padding-top: 10px; border-color: #fff; box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);"
                          >
                            <div class="float-left">
                              <b class="mr-2">{{
                                $t("messages.general.table.paginationinfo")
                              }}</b>
                              <b-form-select
                                v-model="perPage"
                                :options="perPageOptions"
                                size="sm"
                                style="width:70px"
                              />
                            </div>
                            <b-pagination
                              class="float-right"
                              size="sm"
                              :total-rows="bTableCOs.items.length"
                              v-model="currentPage"
                              :per-page="perPage"
                              style="padding-top: 10px"
                            />
                            <div
                              v-if="bTableCOs.items.length > 0"
                              class="float-right data-table-page-info"
                              style="padding-top: 14px"
                            >
                              {{
                                Number(
                                  currentPage > 1
                                    ? (currentPage - 1) * perPage + 1
                                    : currentPage
                                ).toLocaleString()
                              }}
                              -
                              {{
                                Number(
                                  currentPage * perPage > bTableCOs.items.length
                                    ? bTableCOs.items.length
                                    : currentPage * perPage
                                ).toLocaleString()
                              }}
                              {{ $t("messages.general.fromRecords") }}
                              {{
                                Number(bTableCOs.items.length).toLocaleString()
                              }}
                            </div>
                            <div
                              v-if="bTableCOs.items.length <= 0"
                              class="float-right data-table-page-info"
                              style="padding-top: 14px"
                            >
                              0 - 0
                              {{ $t("messages.general.fromRecords") }}
                              {{
                                Number(bTableCOs.items.length).toLocaleString()
                              }}
                            </div>
                          </div>
                        </template>
                      </b-table>
                    </v-card>
                  </v-sheet>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item value="tab-2">
              <v-card flat>
                <v-card-text>
                  <v-sheet>
                    <v-card>
                      <b-table
                        bordered
                        hover
                        small
                        responsive
                        caption-top
                        class="table table-striped text-center"
                        :sort-by.sync="bTableTAs.sortBy"
                        :sort-desc.sync="bTableTAs.sortDesc"
                        :items="bTableTAs.items"
                        :fields="bTableTAs.fields"
                        :per-page="perPage"
                        :current-page="currentPage"
                      >
                        <template slot="table-caption">
                          <div class="float-left">
                            <b class="mr-2">{{
                              $t("messages.general.table.paginationinfo")
                            }}</b>
                            <b-form-select
                              v-model="perPage"
                              :options="perPageOptions"
                              size="sm"
                              style="width:70px"
                            />
                          </div>
                          <b-pagination
                            class="float-right"
                            size="sm"
                            :total-rows="bTableTAs.items.length"
                            v-model="currentPage"
                            :per-page="perPage"
                          />
                          <div
                            v-if="bTableTAs.items.length > 0"
                            class="float-right data-table-page-info"
                          >
                            {{
                              Number(
                                currentPage > 1
                                  ? (currentPage - 1) * perPage + 1
                                  : currentPage
                              ).toLocaleString()
                            }}
                            -
                            {{
                              Number(
                                currentPage * perPage > bTableTAs.items.length
                                  ? bTableTAs.items.length
                                  : currentPage * perPage
                              ).toLocaleString()
                            }}
                            {{ $t("messages.general.fromRecords") }}
                            {{
                              Number(bTableTAs.items.length).toLocaleString()
                            }}
                          </div>
                          <div
                            v-if="bTableTAs.items.length <= 0"
                            class="float-right data-table-page-info"
                          >
                            0 - 0
                            {{ $t("messages.general.fromRecords") }}
                            {{
                              Number(bTableTAs.items.length).toLocaleString()
                            }}
                          </div>
                        </template>
                        <template v-slot:head(selCheckCANMANAGE)="">
                          <label>{{
                            $t("messages.general.editReceiveAmount")
                          }}</label
                          ><br />
                          <input
                            type="checkbox"
                            id="chkAll"
                            @change="handleChkAllT($event, 2)"
                            :checked="
                              bTableTAs.items.length > 0 &&
                                bTableTAs.items.length ==
                                  classTearcherist.length
                            "
                          />
                        </template>
                        <template v-slot:cell(selCheckCANMANAGE)="data">
                          <input
                            type="checkbox"
                            id="chk"
                            @change="handleChkT($event, data, 2)"
                            :checked="data.item.selCheckCANMANAGE"
                          />
                        </template>

                        <template v-slot:head(selCheckCANRESERVE)="">
                          <label>{{
                            $t("messages.general.reserveAseat")
                          }}</label
                          ><br />
                          <input
                            type="checkbox"
                            id="chkAllReserve"
                            @change="handleChkAllTReserve($event, 2)"
                            :checked="
                              bTableTAs.items.length > 0 &&
                                bTableTAs.items.length ==
                                  classTearcheristReserve.length
                            "
                          />
                        </template>
                        <template v-slot:cell(selCheckCANRESERVE)="data">
                          <input
                            type="checkbox"
                            id="chkReserve"
                            @change="handleChkTReserve($event, data, 2)"
                            :checked="data.item.selCheckCANRESERVE"
                          />
                        </template>

                        <template v-slot:head(selCheckCANMOVE)="">
                          <label>{{ $t("messages.general.moveDurCls") }}</label
                          ><br />
                          <input
                            type="checkbox"
                            id="chkAllMove"
                            @change="handleChkAllTMove($event, 2)"
                            :checked="
                              bTableTAs.items.length > 0 &&
                                bTableTAs.items.length ==
                                  classTearcheristMove.length
                            "
                          />
                        </template>
                        <template v-slot:cell(selCheckCANMOVE)="data">
                          <input
                            type="checkbox"
                            id="chkMove"
                            @change="handleChkTMove($event, data, 2)"
                            :checked="data.item.selCheckCANMOVE"
                          />
                        </template>

                        <template v-slot:head(selCheckCANADJUST)="">
                          <label>{{
                            $t("messages.general.classStatusCOP")
                          }}</label
                          ><br />
                          <input
                            type="checkbox"
                            id="chkAllCop"
                            @change="handleChkAllTAdjust($event, 2)"
                            :checked="
                              bTableTAs.items.length > 0 &&
                                bTableTAs.items.length ==
                                  classTearcheristCop.length
                            "
                          />
                        </template>
                        <template v-slot:cell(selCheckCANADJUST)="data">
                          <input
                            type="checkbox"
                            id="chkCop"
                            @change="handleChkTAdjust($event, data, 2)"
                            :checked="data.item.selCheckCANADJUST"
                          />
                        </template>

                        <template v-slot:head(selCheckCANCONFIRM)="">
                          <label>{{ $t("messages.general.confirmReg") }}</label
                          ><br />
                          <input
                            type="checkbox"
                            id="chkAllConfirm"
                            @change="handleChkAllTConfirm($event, 2)"
                            :checked="
                              bTableTAs.items.length > 0 &&
                                bTableTAs.items.length ==
                                  classTearcheristConfirm.length
                            "
                          />
                        </template>
                        <template v-slot:cell(selCheckCANCONFIRM)="data">
                          <input
                            type="checkbox"
                            id="chkConfirm"
                            @change="handleChkTConfirm($event, data, 2)"
                            :checked="data.item.selCheckCANCONFIRM"
                          />
                        </template>

                        <template slot="table-caption">
                          <div
                            style="position: absolute; bottom: -65px; width: 100%; height: 65px; padding-top: 10px; border-color: #fff; box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);"
                          >
                            <div class="float-left">
                              <b class="mr-2">{{
                                $t("messages.general.table.paginationinfo")
                              }}</b>
                              <b-form-select
                                v-model="perPage"
                                :options="perPageOptions"
                                size="sm"
                                style="width:70px"
                              />
                            </div>
                            <b-pagination
                              class="float-right"
                              size="sm"
                              :total-rows="bTableTAs.items.length"
                              v-model="currentPage"
                              :per-page="perPage"
                              style="padding-top: 10px"
                            />
                            <div
                              v-if="bTableTAs.items.length > 0"
                              class="float-right data-table-page-info"
                              style="padding-top: 14px"
                            >
                              {{
                                Number(
                                  currentPage > 1
                                    ? (currentPage - 1) * perPage + 1
                                    : currentPage
                                ).toLocaleString()
                              }}
                              -
                              {{
                                Number(
                                  currentPage * perPage > bTableTAs.items.length
                                    ? bTableTAs.items.length
                                    : currentPage * perPage
                                ).toLocaleString()
                              }}
                              {{ $t("messages.general.fromRecords") }}
                              {{
                                Number(bTableTAs.items.length).toLocaleString()
                              }}
                            </div>
                            <div
                              v-if="bTableTAs.items.length <= 0"
                              class="float-right data-table-page-info"
                              style="padding-top: 14px"
                            >
                              0 - 0
                              {{ $t("messages.general.fromRecords") }}
                              {{
                                Number(bTableTAs.items.length).toLocaleString()
                              }}
                            </div>
                          </div>
                        </template>
                      </b-table>
                    </v-card>
                  </v-sheet>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item value="tab-4">
              <v-card flat>
                <v-card-text>
                  <v-sheet>
                    <v-card>
                      <b-table
                        bordered
                        hover
                        small
                        responsive
                        caption-top
                        class="table table-striped text-center"
                        :sort-by.sync="bTableCOSchedules.sortBy"
                        :sort-desc.sync="bTableCOSchedules.sortDesc"
                        :items="bTableCOSchedules.items"
                        :fields="bTableCOSchedules.fields"
                        :per-page="perPage"
                        :current-page="currentPage"
                      >
                        <template slot="table-caption">
                          <div class="float-left">
                            <b class="mr-2">{{
                              $t("messages.general.table.paginationinfo")
                            }}</b>
                            <b-form-select
                              v-model="perPage"
                              :options="perPageOptions"
                              size="sm"
                              style="width:70px"
                            />
                          </div>
                          <b-pagination
                            class="float-right"
                            size="sm"
                            :total-rows="bTableCOSchedules.items.length"
                            v-model="currentPage"
                            :per-page="perPage"
                          />
                          <div
                            v-if="bTableCOSchedules.items.length > 0"
                            class="float-right data-table-page-info"
                          >
                            {{
                              Number(
                                currentPage > 1
                                  ? (currentPage - 1) * perPage + 1
                                  : currentPage
                              ).toLocaleString()
                            }}
                            -
                            {{
                              Number(
                                currentPage * perPage >
                                  bTableCOSchedules.items.length
                                  ? bTableCOSchedules.items.length
                                  : currentPage * perPage
                              ).toLocaleString()
                            }}
                            {{ $t("messages.general.fromRecords") }}
                            {{
                              Number(
                                bTableCOSchedules.items.length
                              ).toLocaleString()
                            }}
                          </div>
                          <div
                            v-if="bTableCOSchedules.items.length <= 0"
                            class="float-right data-table-page-info"
                          >
                            0 - 0
                            {{ $t("messages.general.fromRecords") }}
                            {{
                              Number(
                                bTableCOSchedules.items.length
                              ).toLocaleString()
                            }}
                          </div>
                        </template>
                        <template v-slot:head(selCheckCANMANAGE)="">
                          <label>{{
                            $t("messages.general.editReceiveAmount")
                          }}</label
                          ><br />
                          <input
                            type="checkbox"
                            id="chkAll"
                            @change="handleChkAllT($event, 4)"
                            :checked="
                              bTableCOSchedules.items.length > 0 &&
                                bTableCOSchedules.items.length ==
                                  classTearcherist.length
                            "
                          />
                        </template>
                        <template v-slot:cell(selCheckCANMANAGE)="data">
                          <input
                            type="checkbox"
                            id="chk"
                            @change="handleChkT($event, data, 4)"
                            :checked="data.item.selCheckCANMANAGE"
                          />
                        </template>

                        <template v-slot:head(selCheckCANRESERVE)="">
                          <label>{{
                            $t("messages.general.reserveAseat")
                          }}</label
                          ><br />
                          <input
                            type="checkbox"
                            id="chkAllReserve"
                            @change="handleChkAllTReserve($event, 4)"
                            :checked="
                              bTableCOSchedules.items.length > 0 &&
                                bTableCOSchedules.items.length ==
                                  classTearcheristReserve.length
                            "
                          />
                        </template>
                        <template v-slot:cell(selCheckCANRESERVE)="data">
                          <input
                            type="checkbox"
                            id="chkReserve"
                            @change="handleChkTReserve($event, data, 4)"
                            :checked="data.item.selCheckCANRESERVE"
                          />
                        </template>

                        <template v-slot:head(selCheckCANMOVE)="">
                          <label>{{ $t("messages.general.moveDurCls") }}</label
                          ><br />
                          <input
                            type="checkbox"
                            id="chkAllMove"
                            @change="handleChkAllTMove($event, 4)"
                            :checked="
                              bTableCOSchedules.items.length > 0 &&
                                bTableCOSchedules.items.length ==
                                  classTearcheristMove.length
                            "
                          />
                        </template>
                        <template v-slot:cell(selCheckCANMOVE)="data">
                          <input
                            type="checkbox"
                            id="chkMove"
                            @change="handleChkTMove($event, data, 4)"
                            :checked="data.item.selCheckCANMOVE"
                          />
                        </template>

                        <template v-slot:head(selCheckCANADJUST)="">
                          <label>{{
                            $t("messages.general.classStatusCOP")
                          }}</label
                          ><br />
                          <input
                            type="checkbox"
                            id="chkAllCop"
                            @change="handleChkAllTAdjust($event, 4)"
                            :checked="
                              bTableCOSchedules.items.length > 0 &&
                                bTableCOSchedules.items.length ==
                                  classTearcheristCop.length
                            "
                          />
                        </template>
                        <template v-slot:cell(selCheckCANADJUST)="data">
                          <input
                            type="checkbox"
                            id="chkCop"
                            @change="handleChkTAdjust($event, data, 4)"
                            :checked="data.item.selCheckCANADJUST"
                          />
                        </template>

                        <template v-slot:head(selCheckCANCONFIRM)="">
                          <label>{{ $t("messages.general.confirmReg") }}</label
                          ><br />
                          <input
                            type="checkbox"
                            id="chkAllConfirm"
                            @change="handleChkAllTConfirm($event, 4)"
                            :checked="
                              bTableCOSchedules.items.length > 0 &&
                                bTableCOSchedules.items.length ==
                                  classTearcheristConfirm.length
                            "
                          />
                        </template>
                        <template v-slot:cell(selCheckCANCONFIRM)="data">
                          <input
                            type="checkbox"
                            id="chkConfirm"
                            @change="handleChkTConfirm($event, data, 4)"
                            :checked="data.item.selCheckCANCONFIRM"
                          />
                        </template>

                        <template slot="table-caption">
                          <div
                            style="position: absolute; bottom: -65px; width: 100%; height: 65px; padding-top: 10px; border-color: #fff; box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);"
                          >
                            <div class="float-left">
                              <b class="mr-2">{{
                                $t("messages.general.table.paginationinfo")
                              }}</b>
                              <b-form-select
                                v-model="perPage"
                                :options="perPageOptions"
                                size="sm"
                                style="width:70px"
                              />
                            </div>
                            <b-pagination
                              class="float-right"
                              size="sm"
                              :total-rows="bTableCOSchedules.items.length"
                              v-model="currentPage"
                              :per-page="perPage"
                              style="padding-top: 10px"
                            />
                            <div
                              v-if="bTableCOSchedules.items.length > 0"
                              class="float-right data-table-page-info"
                              style="padding-top: 14px"
                            >
                              {{
                                Number(
                                  currentPage > 1
                                    ? (currentPage - 1) * perPage + 1
                                    : currentPage
                                ).toLocaleString()
                              }}
                              -
                              {{
                                Number(
                                  currentPage * perPage >
                                    bTableCOSchedules.items.length
                                    ? bTableCOSchedules.items.length
                                    : currentPage * perPage
                                ).toLocaleString()
                              }}
                              {{ $t("messages.general.fromRecords") }}
                              {{
                                Number(
                                  bTableCOSchedules.items.length
                                ).toLocaleString()
                              }}
                            </div>
                            <div
                              v-if="bTableCOSchedules.items.length <= 0"
                              class="float-right data-table-page-info"
                              style="padding-top: 14px"
                            >
                              0 - 0
                              {{ $t("messages.general.fromRecords") }}
                              {{
                                Number(
                                  bTableCOSchedules.items.length
                                ).toLocaleString()
                              }}
                            </div>
                          </div>
                        </template>
                      </b-table>
                    </v-card>
                  </v-sheet>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs>
        </form>
      </div>
    </div>

    <v-dialog
      v-model="dialogSearchProgram"
      hide-overlay
      scrollable
      max-width="80%"
    >
      <v-card tile>
        <v-toolbar flat dense>
          <v-icon>search</v-icon>
          <v-toolbar-title>{{
            $t("messages.general.classList")
          }}</v-toolbar-title>
          <div class="flex-grow-1"></div>
          <v-toolbar-items>
            <v-btn icon @click="dialogSearchProgram = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text dark>
          <!-- <v-card width="100%">
            <v-row>
              <v-col
                class="text-danger"
                style="padding-top: 0; padding-bottom: 0; padding-right: 25px;"
              >
                <p style="margin: 0; text-align: right;">
                  {{ $t("messages.general.programCodeNameReq") }}
                </p>
              </v-col>
            </v-row>
          </v-card> -->
          <form>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>{{ $t("messages.general.classId") }} </label>
                  </div>
                  <div class="col no-margin-padding">
                    <div>
                      <input
                        v-model="dlgCourseCode"
                        type="text"
                        class="form-control col mr-2"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>{{ $t("messages.general.className") }}</label>
                  </div>
                  <div class="col no-margin-padding">
                    <div>
                      <input
                        v-model="dlgCourseName"
                        type="text"
                        class="form-control col mr-2"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>{{ $t("messages.general.faculty") }}</label>
                  </div>
                  <div class="col no-margin-padding">
                    <Faculty
                      :onChanged="onSelFacultyCourseChanged"
                      :selectedVal="selFacultyCourse"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>{{ $t("messages.general.department") }}</label>
                  </div>
                  <div class="col no-margin-padding">
                    <Department
                      :onChanged="onSelDepartmentCourseChanged"
                      :facultyid="selFacultyCourse"
                      :selectedVal="selDepartmentCourse"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div
              class="form-row flex-column justify-content-center align-items-center mt-5"
            >
              <div class="form-group">
                <div class="form-inline">
                  <button
                    class="btn btn-primary btn-lg"
                    type="button"
                    @click="handleCourseSearch()"
                  >
                    {{ $t("messages.general.search") }}</button
                  >&nbsp;&nbsp;&nbsp;
                  <button
                    class="btn btn-light btn-lg"
                    type="button"
                    @click="cleartCourseProgram()"
                  >
                    {{ $t("messages.general.clearScreen") }}</button
                  >&nbsp;&nbsp;&nbsp;
                </div>
              </div>
            </div>
          </form>
          <v-card>
            <b-table
              bordered
              hover
              small
              responsive
              caption-top
              class="table table-striped text-center"
              :sort-by.sync="bTableProgram.sortBy"
              :sort-desc.sync="bTableProgram.sortDesc"
              :items="bTableProgram.items"
              :fields="bTableProgram.fields"
              :per-page="perPage"
              :current-page="currentPageProgram"
            >
              <template slot="table-caption">
                <div class="float-left">
                  <b class="mr-2">{{
                    $t("messages.general.table.paginationinfo")
                  }}</b>
                  <b-form-select
                    v-model="perPage"
                    :options="perPageOptions"
                    size="sm"
                    style="width:70px"
                  />
                </div>
                <b-pagination
                  class="float-right"
                  size="sm"
                  :total-rows="bTableProgram.items.length"
                  v-model="currentPageProgram"
                  :per-page="perPage"
                />
                <div
                  v-if="bTableProgram.items.length > 0"
                  class="float-right data-table-page-info"
                >
                  {{
                    Number(
                      currentPageProgram > 1
                        ? (currentPageProgram - 1) * perPage + 1
                        : currentPageProgram
                    ).toLocaleString()
                  }}
                  -
                  {{
                    Number(
                      currentPageProgram * perPage > bTableProgram.items.length
                        ? bTableProgram.items.length
                        : currentPageProgram * perPage
                    ).toLocaleString()
                  }}
                  {{ $t("messages.general.fromRecords") }}
                  {{ Number(bTableProgram.items.length).toLocaleString() }}
                </div>
                <div
                  v-if="bTableProgram.items.length <= 0"
                  class="float-right data-table-page-info"
                >
                  0 - 0
                  {{ $t("messages.general.fromRecords") }}
                  {{ Number(bTableProgram.items.length).toLocaleString() }}
                </div>
              </template>

              <template v-slot:cell(COURSECODE)="data">
                <a
                  @click="handleSelectCourse(data.item, data.index)"
                  style="text-decoration: underline;"
                >
                  {{ data.item.COURSECODE }}
                </a>
              </template>

              <template slot="table-caption">
                <div
                  style="position: absolute; bottom: -65px; width: 100%; height: 65px; padding-top: 10px; border-color: #fff; box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);"
                >
                  <div class="float-left">
                    <b class="mr-2">{{
                      $t("messages.general.table.paginationinfo")
                    }}</b>
                    <b-form-select
                      v-model="perPage"
                      :options="perPageOptions"
                      size="sm"
                      style="width:70px"
                    />
                  </div>
                  <b-pagination
                    class="float-right"
                    size="sm"
                    :total-rows="bTableProgram.items.length"
                    v-model="currentPageProgram"
                    :per-page="perPage"
                    style="padding-top: 10px"
                  />
                  <div
                    v-if="bTableProgram.items.length > 0"
                    class="float-right data-table-page-info"
                    style="padding-top: 14px"
                  >
                    {{
                      Number(
                        currentPageProgram > 1
                          ? (currentPageProgram - 1) * perPage + 1
                          : currentPageProgram
                      ).toLocaleString()
                    }}
                    -
                    {{
                      Number(
                        currentPageProgram * perPage >
                          bTableProgram.items.length
                          ? bTableProgram.items.length
                          : currentPageProgram * perPage
                      ).toLocaleString()
                    }}
                    {{ $t("messages.general.fromRecords") }}
                    {{ Number(bTableProgram.items.length).toLocaleString() }}
                  </div>
                  <div
                    v-if="bTableProgram.items.length <= 0"
                    class="float-right data-table-page-info"
                    style="padding-top: 14px"
                  >
                    0 - 0
                    {{ $t("messages.general.fromRecords") }}
                    {{ Number(bTableProgram.items.length).toLocaleString() }}
                  </div>
                </div>
              </template>
            </b-table>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dlgCopyAuthorization"
      hide-overlay
      scrollable
      max-width="50%"
    >
      <v-card tile>
        <v-toolbar flat dense>
          <v-icon>edit</v-icon>
          <v-toolbar-title
            >{{ $t("messages.general.section") }}{{ selectedDetail.SECTION
            }}{{ $t("messages.general.copytosec") }}</v-toolbar-title
          >
          <div class="flex-grow-1"></div>
          <v-toolbar-items>
            <v-btn icon @click="dlgCopyAuthorization = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text dark>
          <div class="form-row">
            <div class="col no-padding-bottom">
              <div class="information-detail-white">
                <div class="col no-margin-padding">
                  <input
                    type="checkbox"
                    id="chkSectionAll"
                    @change="handleSectionChkAll($event)"
                    :checked="
                      sections.filter((s) => s.isCheck).length ==
                        sections.filter((x) => x.CLASSID != selected.CLASSID)
                          .length
                    "
                  />&nbsp;&nbsp;&nbsp;
                  <label>{{ $t("messages.general.selectAlls") }}</label>
                </div>
              </div>
            </div>
          </div>
          <div v-for="(item, index) in sections" :key="index" class="form-row">
            <div class="col no-padding-bottom">
              <div class="information-detail-white">
                <div class="col no-margin-padding">
                  <input
                    type="checkbox"
                    :id="'chkSection_' + item.CLASSID"
                    :checked="item.isCheck"
                    @change="handleSectionChk($event, item)"
                    :disabled="item.disabled"
                  />&nbsp;&nbsp;&nbsp;
                  <label>{{
                    `${$t("messages.general.section")} ${item.SECTION_TEXT}`
                  }}</label>
                </div>
              </div>
            </div>
          </div>
          <div
            class="form-row flex-column justify-content-center align-items-center mt-5"
          >
            <div class="form-group">
              <div class="form-inline">
                <button
                  class="btn btn-primary btn-lg"
                  type="button"
                  @click="saveCopySection()"
                >
                  {{ $t("messages.general.save") }}</button
                >&nbsp;&nbsp;&nbsp;
                <button
                  class="btn btn-light btn-lg"
                  type="button"
                  @click="cancelCopySection()"
                >
                  {{ $t("messages.general.cancel") }}</button
                >&nbsp;&nbsp;&nbsp;
              </div>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogConfirmSuccess" max-width="600px">
      <v-card tile>
        <v-toolbar flat dense color="light-green accent-3">
          <v-icon color="light-green darken-2">fa-check</v-icon>
          <v-toolbar-title style="color: green;"
            >&nbsp;{{
              $t("messages.reqRegister.confirmPopupText")
            }}</v-toolbar-title
          >
          <div class="flex-grow-1"></div>
          <v-toolbar-items>
            <v-btn icon @click="dialogConfirmSuccess = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text dark color="green accent-1">
          <br />
          <span v-html="successText" style="color: green;">{{
            successText
          }}</span>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogError" max-width="600px">
      <v-card tile>
        <v-toolbar flat dense color="red darken-3">
          <v-icon color="red lighten-5">fa-exclamation-circle</v-icon>
          <v-toolbar-title style="color: #ffebee;"
            >&nbsp;{{ dialogErrorTitle }}</v-toolbar-title
          >
          <div class="flex-grow-1"></div>
          <v-toolbar-items>
            <v-btn icon @click="dialogError = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text dark color="red accent-1">
          <br />
          <span style="color: red;" v-html="errorText">{{ errorText }}</span>
        </v-card-text>
      </v-card>
    </v-dialog>
  </section>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import AcademicYear from "../components/Dropdown/AcademicYear";
import Semester from "../components/Dropdown/Semester";
import Level from "@/components/Dropdown/Level.vue";
import Faculty from "@/components/Dropdown/Faculty.vue";
import Department from "@/components/Dropdown/Department.vue";
import MasterDataProvider from "@/services/masterData_provider";
import EnrollProvider from "@/services/enroll_provider";

const masterDataProvider = new MasterDataProvider();
const enrollProvider = new EnrollProvider();

export default {
  name: "confirmReqRegister",
  components: {
    AcademicYear,
    Semester,
    Level,
    Faculty,
    Department,
  },
  data() {
    return {
      dialogSearchProgram: false,
      dlgCopyAuthorization: false,
      selYear: 0,
      selSemester: 0,
      selLvl: 0,
      selSection: "00",
      selFacultyProgram: "0",
      selDepartmentProgram: "0",
      courseCode: "",
      courseName: "",
      sections: [],
      items: [],
      mode: "",
      selTab: "",
      bTable: {
        sortBy: "rowNumber",
        sortDesc: false,
        items: [],
        fields: [
          {
            key: "action",
            label: "",
            thClass: "align-middle",
            thStyle: "width: 50px",
            sortable: true,
          },
          {
            key: "rowNumber",
            label: this.$t("messages.general.seqOrder"),
            thClass: "align-middle",
            thStyle: "width: 50px",
            sortable: true,
          },
          {
            key: "LEVELNAME",
            label: this.$t("messages.general.educationLvl"),
            thClass: "align-middle",
            thStyle: "width: 200px",
            tdClass: "text-left text-nowarp",
            sortable: true,
          },
          {
            key: "COURSECODE",
            label: this.$t("messages.general.classId"),
            thClass: "align-middle",
            thStyle: "width: 100px",
            sortable: true,
          },
          {
            key: "COURSENAMEENG",
            label: this.$t("messages.general.className"),
            thClass: "align-middle",
            thStyle: "width: 350px",
            tdClass: "text-left text-nowarp",
            sortable: true,
          },
          {
            key: "SECTION",
            label: this.$t("messages.general.section"),
            thClass: "align-middle",
            tdClass: "text-right text-nowarp col-100",
            sortable: true,
          },
          {
            key: "COORDINATORCOUNT",
            label: this.$t("messages.general.coorSchedAmount"),
            thClass: "align-middle",
            tdClass: "text-right text-nowarp col-100",
            sortable: true,
          },
        ],
      },
      bTableAssignByFaculty: {
        sortBy: "rowNumber",
        sortDesc: false,
        items: [],
        fields: [
          {
            key: "COURSECODE",
            label: this.$t("messages.general.classId"),
            thClass: "align-middle",
            thStyle: "width: 120px",
            sortable: true,
          },
          {
            key: "COURSENAME",
            label: this.$t("messages.general.className"),
            thClass: "align-middle",
            tdClass: "text-left text-nowarp",
            sortable: true,
          },
          {
            key: "SECTION",
            label: this.$t("messages.general.section"),
            thClass: "align-middle",
            thStyle: "width: 120px",
            sortable: true,
          },
          {
            key: "selCheckINSTRUCTORSTATUS",
            label: this.$t("messages.general.teachers"),
            thClass: "align-middle",
            thStyle: "width: 120px",
            sortable: true,
          },
          {
            key: "selCheckCOCOURSESTATUS",
            label: this.$t("messages.general.coordinatorforCourse"),
            thClass: "align-middle",
            thStyle: "width: 120px",
            sortable: true,
          },
          {
            key: "selCheckTASTATUS",
            label: this.$t("messages.general.assistantForTeach"),
            thClass: "align-middle",
            thStyle: "width: 120px",
            sortable: true,
          },
          {
            key: "selCheckCOEXAMSTATUS",
            label: this.$t("messages.general.coorSched"),
            thClass: "align-middle",
            thStyle: "width: 120px",
            sortable: true,
          },
        ],
      },
      bTableTeachers: {
        sortBy: "rowNumber",
        sortDesc: false,
        items: [],
        fields: [
          {
            key: "rowNumber",
            label: this.$t("messages.general.seqOrder"),
            thClass: "align-middle",
            thStyle: "width: 50px",
            sortable: true,
          },
          {
            key: "OFFICERCODE",
            label: this.$t("messages.general.identity"),
            thClass: "align-middle",
            sortable: true,
          },
          {
            key: "OFFICERNAME",
            label: this.$t("messages.general.fullname"),
            thClass: "align-middle",
            tdClass: "text-left",
            sortable: true,
          },
          {
            key: "FACULTYNAME",
            label: this.$t("messages.general.underFac"),
            thClass: "align-middle",
            tdClass: "text-left text-nowarp",
            sortable: true,
          },
          {
            key: "GENDER",
            label: this.$t("messages.general.gender"),
            thClass: "align-middle",
            tdClass: "text-left text-nowarp",
            sortable: true,
          },
          {
            key: "selCheckCANMANAGE",
            label: this.$t("messages.general.editReceiveAmount"),
            thClass: "align-middle",
            tdClass: "text-middle text-nowarp",
            sortable: true,
          },
          {
            key: "selCheckCANRESERVE",
            label: this.$t("messages.general.reserveAseat"),
            thClass: "align-middle",
            tdClass: "text-middle text-nowarp",
            sortable: true,
          },
          {
            key: "selCheckCANMOVE",
            label: this.$t("messages.general.moveDurCls"),
            thClass: "align-middle",
            tdClass: "text-middle text-nowarp",
            sortable: true,
          },
          {
            key: "selCheckCANADJUST",
            label: this.$t("messages.general.classStatusCOP"),
            thClass: "align-middle",
            tdClass: "text-middle text-nowarp",
            sortable: true,
          },
          {
            key: "selCheckCANCONFIRM",
            label: this.$t("messages.general.confirmReg"),
            thClass: "align-middle",
            tdClass: "text-middle text-nowarp",
            sortable: true,
          },
        ],
      },
      bTableTAs: {
        sortBy: "rowNumber",
        sortDesc: false,
        items: [],
        fields: [
          {
            key: "rowNumber",
            label: this.$t("messages.general.seqOrder"),
            thClass: "align-middle",
            thStyle: "width: 50px",
            sortable: true,
          },
          {
            key: "OFFICERCODE",
            label: this.$t("messages.general.identity"),
            thClass: "align-middle",
            sortable: true,
          },
          {
            key: "OFFICERNAME",
            label: this.$t("messages.general.fullname"),
            thClass: "align-middle",
            tdClass: "text-left",
            sortable: true,
          },
          {
            key: "FACULTYNAME",
            label: this.$t("messages.general.underFac"),
            thClass: "align-middle",
            tdClass: "text-left text-nowarp",
            sortable: true,
          },
          {
            key: "GENDER",
            label: this.$t("messages.general.gender"),
            thClass: "align-middle",
            tdClass: "text-left text-nowarp",
            sortable: true,
          },
          {
            key: "selCheckCANMANAGE",
            label: this.$t("messages.general.editReceiveAmount"),
            thClass: "align-middle",
            tdClass: "text-middle text-nowarp",
            sortable: true,
          },
          {
            key: "selCheckCANRESERVE",
            label: this.$t("messages.general.reserveAseat"),
            thClass: "align-middle",
            tdClass: "text-middle text-nowarp",
            sortable: true,
          },
          {
            key: "selCheckCANMOVE",
            label: this.$t("messages.general.moveDurCls"),
            thClass: "align-middle",
            tdClass: "text-middle text-nowarp",
            sortable: true,
          },
          {
            key: "selCheckCANADJUST",
            label: this.$t("messages.general.classStatusCOP"),
            thClass: "align-middle",
            tdClass: "text-middle text-nowarp",
            sortable: true,
          },
          {
            key: "selCheckCANCONFIRM",
            label: this.$t("messages.general.confirmReg"),
            thClass: "align-middle",
            tdClass: "text-middle text-nowarp",
            sortable: true,
          },
        ],
      },
      bTableCOs: {
        sortBy: "rowNumber",
        sortDesc: false,
        items: [],
        fields: [
          {
            key: "rowNumber",
            label: this.$t("messages.general.seqOrder"),
            thClass: "align-middle",
            thStyle: "width: 50px",
            sortable: true,
          },
          {
            key: "OFFICERCODE",
            label: this.$t("messages.general.identity"),
            thClass: "align-middle",
            sortable: true,
          },
          {
            key: "OFFICERNAME",
            label: this.$t("messages.general.fullname"),
            thClass: "align-middle",
            tdClass: "text-left",
            sortable: true,
          },
          {
            key: "FACULTYNAME",
            label: this.$t("messages.general.underFac"),
            thClass: "align-middle",
            tdClass: "text-left text-nowarp",
            sortable: true,
          },
          {
            key: "GENDER",
            label: this.$t("messages.general.gender"),
            thClass: "align-middle",
            tdClass: "text-left text-nowarp",
            sortable: true,
          },
          {
            key: "selCheckCANMANAGE",
            label: this.$t("messages.general.editReceiveAmount"),
            thClass: "align-middle",
            tdClass: "text-middle text-nowarp",
            sortable: true,
          },
          {
            key: "selCheckCANRESERVE",
            label: this.$t("messages.general.reserveAseat"),
            thClass: "align-middle",
            tdClass: "text-middle text-nowarp",
            sortable: true,
          },
          {
            key: "selCheckCANMOVE",
            label: this.$t("messages.general.moveDurCls"),
            thClass: "align-middle",
            tdClass: "text-middle text-nowarp",
            sortable: true,
          },
          {
            key: "selCheckCANADJUST",
            label: this.$t("messages.general.classStatusCOP"),
            thClass: "align-middle",
            tdClass: "text-middle text-nowarp",
            sortable: true,
          },
          {
            key: "selCheckCANCONFIRM",
            label: this.$t("messages.general.confirmReg"),
            thClass: "align-middle",
            tdClass: "text-middle text-nowarp",
            sortable: true,
          },
        ],
      },
      bTableCOSchedules: {
        sortBy: "rowNumber",
        sortDesc: false,
        items: [],
        fields: [
          {
            key: "rowNumber",
            label: this.$t("messages.general.seqOrder"),
            thClass: "align-middle",
            thStyle: "width: 50px",
            sortable: true,
          },
          {
            key: "OFFICERCODE",
            label: this.$t("messages.general.identity"),
            thClass: "align-middle",
            sortable: true,
          },
          {
            key: "OFFICERNAME",
            label: this.$t("messages.general.fullname"),
            thClass: "align-middle",
            tdClass: "text-left",
            sortable: true,
          },
          {
            key: "FACULTYNAME",
            label: this.$t("messages.general.underFac"),
            thClass: "align-middle",
            tdClass: "text-left text-nowarp",
            sortable: true,
          },
          {
            key: "GENDER",
            label: this.$t("messages.general.gender"),
            thClass: "align-middle",
            tdClass: "text-left text-nowarp",
            sortable: true,
          },
          {
            key: "selCheckCANMANAGE",
            label: this.$t("messages.general.editReceiveAmount"),
            thClass: "align-middle",
            tdClass: "text-middle text-nowarp",
            sortable: true,
          },
          {
            key: "selCheckCANRESERVE",
            label: this.$t("messages.general.reserveAseat"),
            thClass: "align-middle",
            tdClass: "text-middle text-nowarp",
            sortable: true,
          },
          {
            key: "selCheckCANMOVE",
            label: this.$t("messages.general.moveDurCls"),
            thClass: "align-middle",
            tdClass: "text-middle text-nowarp",
            sortable: true,
          },
          {
            key: "selCheckCANADJUST",
            label: this.$t("messages.general.classStatusCOP"),
            thClass: "align-middle",
            tdClass: "text-middle text-nowarp",
            sortable: true,
          },
          {
            key: "selCheckCANCONFIRM",
            label: this.$t("messages.general.confirmReg"),
            thClass: "align-middle",
            tdClass: "text-middle text-nowarp",
            sortable: true,
          },
        ],
      },
      bTableProgram: {
        sortBy: "rowNumber",
        sortDesc: false,
        items: [],
        fields: [
          {
            key: "rowNumber",
            label: this.$t("messages.general.seqOrder"),
            thClass: "align-middle",
            thStyle: "width: 50px",
            sortable: true,
          },
          {
            key: "COURSECODE",
            label: this.$t("messages.general.classId"),
            thClass: "align-middle",
            thStyle: "width: 100px",
            sortable: true,
          },
          {
            key: "COURSENAME",
            label: this.$t("messages.general.className"),
            thClass: "align-middle",
            tdClass: "text-left text-nowarp",
            sortable: true,
          },
          {
            key: "FACULTYNAME",
            label: this.$t("messages.general.faculty"),
            thClass: "align-middle",
            thStyle: "width: 170px",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
          {
            key: "DEPARTMENTNAME",
            label: this.$t("messages.general.department"),
            thClass: "align-middle",
            thStyle: "width: 170px",
            tdClass: "text-left text-nowarp",
            sortable: true,
          },
          {
            key: "COURSEUNIT",
            label: this.$t("messages.general.credit"),
            thClass: "align-middle",
            thStyle: "width: 100px",
            tdClass: "text-center text-nowarp",
          },
        ],
      },
      perPageOptions: [
        { value: 10, text: 10 },
        { value: 50, text: 50 },
        { value: 100, text: 100 },
        { value: 500, text: 500 },
        { value: 1000, text: 1000 },
        { value: 2000, text: 2000 },
        { value: 3000, text: 3000 },
      ],
      perPage: 100,
      perPageStudentReg: 50,
      currentPage: 1,
      currentPageProgram: 1,
      searched: false,
      selected: false,
      selectedIdx: 0,
      isEdit: false,
      isSpecial: false,
      selectedDetail: false,
      dlgCourseCode: "",
      dlgCourseName: "",
      selDepartmentCourse: 0,
      selFacultyCourse: 0,
      selectedClsId: 0,
      dialogConfirmSuccess: false,
      successText: "",
      dialogError: false,
      errorText: "",
      dialogErrorTitle: "",
      confirmType: 0,
      totalRequest: 0,
      totalConfirm: "",
      currentPageStudentReg: 1,
      studentIdList: [],
      studentList: [],
      totalSumSeat: "",
      classTearcherist: [],
      classTearcheristReserve: [],
      classTearcheristMove: [],
      classTearcheristCop: [],
      classTearcheristConfirm: [],
      classCoorCourseList: [],
      classAssisTeachList: [],
      classSchedList: [],
      instructorList: [],
      coCourseList: [],
      classCodeFacList: [],
      taList: [],
      coExamList: [],
      courseId: "",
      selYearFac: 0,
      selSemesterFac: 0,
      selLvlFac: 3,
      selFacultyProgramFac: "0",
      selDepartmentProgramFac: "0",
      listTypeCode1: [],
      listTypeCode2: [],
      listTypeCode3: [],
      listTypeCode4: [],
    };
  },
  computed: {
    ...mapGetters("application", {
      appInfo: "getUserInfo",
      token: "getToken",
      userId: "getUserId",
      mfuUserId: "getMfuUserId",
    }),
    currentLang: function() {
      return this.appInfo.currentLocale;
    },
  },
  mounted() {
    this.tokenHealthChk();
    this.togglePreLoader(true);
    this.selYear = this.appInfo.data.ENROLL_ACADYEAR;
    this.selSemester = this.appInfo.data.ENROLL_SEMESTER;
    this.selYearFac = this.appInfo.data.ENROLL_ACADYEAR;
    this.selSemesterFac = this.appInfo.data.ENROLL_SEMESTER;
    this.selLvl = 3;
    this.selLvlFac = 3;
    this.selSection = "00";
    this.togglePreLoader(false);
  },
  methods: {
    ...mapActions("application", ["togglePreLoader", "tokenHealthChk"]),
    onSelYearChanged(event) {
      this.selYear = parseInt(event.target.value);
      this.getSections();
    },
    onSelSemesterChanged(event) {
      this.selSemester = parseInt(event.target.value);
      this.getSections();
    },
    onSelLvlChanged(event) {
      this.selLvl = parseInt(event.target.value);
    },
    onSelSectionChanged(event) {
      this.selSection = event.target.value;
    },
    onSelYearChangedFac(event) {
      this.selYearFac = parseInt(event.target.value);
      this.getSections();
    },
    onSelSemesterChangedFac(event) {
      this.selSemesterFac = parseInt(event.target.value);
      this.getSections();
    },
    onSelLvlChangedFac(event) {
      this.selLvlFac = parseInt(event.target.value);
    },
    // onSelSectionChanged(event) {
    //   this.selSection = event.target.value;
    // },
    onSelFacultyCourseChanged() {
      this.selFacultyCourse = parseInt(event.target.value);
    },
    onSelDepartmentCourseChanged(event) {
      this.selDepartmentCourse = parseInt(event.target.value);
    },
    onSelFacultyProgramChangedFac() {
      this.selFacultyProgramFac = parseInt(event.target.value);
    },
    onSelDepartmentProgramChangedFac(event) {
      this.selDepartmentProgramFac = parseInt(event.target.value);
    },
    handleSearchClsKey(event) {
      if (event.charCode == 13) {
        this.handleSearchCls();
      }
    },
    copyAuthorization() {
      this.dlgCopyAuthorization = true;
    },
    async handleSearchCls() {
      if (this.courseCode != "") {
        this.togglePreLoader(true);
        const result = await enrollProvider.getCourseByAcad({
          token: this.token,
          request: {
            coursecode: this.courseCode,
            acadyear: this.selYear,
            semester: this.selSemester,
            levelid: this.selLvl,
            lang: this.currentLang,
          },
        });
        // Fix Dropdown Course List Found Multiple Course
        if (result.code != 500 && result.data.length > 0) {
          if (
            result.data.length == 1 ||
            result.data[0].COURSECODE == this.courseCode
          ) {
            this.handleSelectClass(result.data[0]);
            this.courseList = result;
          } else {
            this.courseList = result;
            this.dlgCourseCode = this.courseCode;
            this.dialogSearchProgram = true;
            this.bTableProgram.items = [];
            if (result.data.length > 0) {
              let idx = 0;
              result.data.map((d) => {
                d.rowNumber = idx + 1;
                this.bTableProgram.items.push(d);
                idx++;
              });
            }
          }
        } else {
          this.dialogError = true;
          this.errorText = result.message;
        }
        this.togglePreLoader(false);
      } else {
        this.handleShowDlgSearchCourse();
      }
    },
    async saveCoordinatorrightbyco(tempItem, isAll) {
      const req = {
        token: this.token,
        request: {
          coordinator_hdid: tempItem.COORDINATOR_HD_ID,
          officerid: +tempItem.OFFICERID,
          can_adjust: tempItem.CAN_ADJUST,
          can_confirm: tempItem.CAN_CONFIRM,
          can_manage: tempItem.CAN_MANAGE,
          can_move: tempItem.CAN_MOVE,
          can_resereve: tempItem.CAN_RESERVE,
          usertype_code: +tempItem.TYPE_CODE,
          userid: this.mfuUserId,
          lang: this.currentLang,
        },
      };
      if (!isAll) {
        this.togglePreLoader(true);
      }
      const result = await enrollProvider.saveCoordinatorrightbyco(req);
      if (isAll) return result;
      if (result.status == 200) {
        // this.dialogConfirmSuccess = true;
        // this.successText = `${result.message}<br/>`;
      } else {
        this.dialogErrorTitle = "";
        this.dialogError = true;
        this.errorText = `${result.message}`;
      }
      if (!isAll) {
        this.togglePreLoader(false);
      }
    },
    async saveCoordinatorrightbyfac(tempItem, uCode, isCheck, isList = false) {
      this.togglePreLoader(true);
      const req = {
        token: this.token,
        request: {
          classid_list: isList
            ? tempItem.map((i) => +i.CLASSID)
            : [+tempItem.CLASSID],
          usertypecode: +uCode,
          permit: isCheck ? "Y" : "N",
          userid: this.mfuUserId,
          lang: this.currentLang,
        },
      };
      const result = await enrollProvider.saveCoordinatorrightbyfac(req);
      this.togglePreLoader(false);
      if (result.status == 200) {
        // this.dialogConfirmSuccess = true;
        // this.successText = `${result.message}<br/>`;
      } else {
        this.dialogErrorTitle = "";
        this.dialogError = true;
        this.errorText = `${result.message}`;
      }
    },
    async saveCoordinatorrightbycoAll(items, isChecked, chkType) {
      this.togglePreLoader(true);
      let listErrMsg = "";
      let resMsg = "";
      for (let x = 0; x < items.length; x++) {
        const i = items[x];
        if (chkType == 1) {
          i.selCheckCANMANAGE = isChecked;
          i.CAN_MANAGE = isChecked ? "Y" : "N";
        } else if (chkType == 2) {
          i.selCheckCANRESERVE = isChecked;
          i.CAN_RESERVE = isChecked ? "Y" : "N";
        } else if (chkType == 3) {
          i.selCheckCANMOVE = isChecked;
          i.CAN_MOVE = isChecked ? "Y" : "N";
        } else if (chkType == 4) {
          i.selCheckCANADJUST = isChecked;
          i.CAN_ADJUST = isChecked ? "Y" : "N";
        } else if (chkType == 5) {
          i.selCheckCANCONFIRM = isChecked;
          i.CAN_CONFIRM = isChecked ? "Y" : "N";
        }
        const res = await this.saveCoordinatorrightbyco(i, true);
        if (res.status != 200) {
          listErrMsg += `${res.message}<br/>`;
        } else {
          resMsg = `${res.message}<br/>`;
        }
        // if (isChecked) {
        //   this.classTearcherist.push(i.CAN_MANAGE);
        // }
      }
      this.togglePreLoader(false);
      if (listErrMsg != "") {
        this.dialogErrorTitle = "";
        this.dialogError = true;
        this.errorText = `${listErrMsg}`;
      } else {
        // this.dialogConfirmSuccess = true;
        // this.successText = `${resMsg}`;
      }
    },
    async handleChkAllT(e, typeCode) {
      let temp = [];
      if (typeCode == 1) {
        temp = this.bTableTeachers.items;
      } else if (typeCode == 2) {
        temp = this.bTableTAs.items;
      } else if (typeCode == 3) {
        temp = this.bTableCOs.items;
      } else if (typeCode == 4) {
        temp = this.bTableCOSchedules.items;
      }
      await this.saveCoordinatorrightbycoAll(temp, e.target.checked, 1);
      // if (!isChecked) {
      //   this.classTearcherist = [];
      // }
    },
    async handleChkT(e, data, typeCode) {
      const isChecked = e.target.checked;
      const { item, index } = data;
      let temp = [];
      if (typeCode == 1) {
        temp = this.bTableTeachers.items;
      } else if (typeCode == 2) {
        temp = this.bTableTAs.items;
      } else if (typeCode == 3) {
        temp = this.bTableCOs.items;
      } else if (typeCode == 4) {
        temp = this.bTableCOSchedules.items;
      }
      temp[index].selCheckCANMANAGE = isChecked;
      temp[index].CAN_MANAGE = isChecked ? "Y" : "N";
      await this.saveCoordinatorrightbyco(temp[index], false, 1);
      // if (isChecked) {
      //   this.classTearcherist.push(item.CAN_MANAGE);

      // } else {
      //   const newArr = this.classTearcherist.filter(
      //     (s) => s != item.CAN_MANAGE
      //   );
      //   this.classTearcherist = newArr;
      // }
    },
    async handleChkAllTReserve(e, typeCode) {
      let temp = [];
      if (typeCode == 1) {
        temp = this.bTableTeachers.items;
      } else if (typeCode == 2) {
        temp = this.bTableTAs.items;
      } else if (typeCode == 3) {
        temp = this.bTableCOs.items;
      } else if (typeCode == 4) {
        temp = this.bTableCOSchedules.items;
      }
      await this.saveCoordinatorrightbycoAll(temp, e.target.checked, 2);
    },
    async handleChkTReserve(e, data, typeCode) {
      const isChecked = e.target.checked;
      const { item, index } = data;
      let temp = [];
      if (typeCode == 1) {
        temp = this.bTableTeachers.items;
      } else if (typeCode == 2) {
        temp = this.bTableTAs.items;
      } else if (typeCode == 3) {
        temp = this.bTableCOs.items;
      } else if (typeCode == 4) {
        temp = this.bTableCOSchedules.items;
      }
      temp[index].selCheckCANRESERVE = isChecked;
      temp[index].CAN_RESERVE = isChecked ? "Y" : "N";
      await this.saveCoordinatorrightbyco(temp[index], false, 2);
    },
    async handleChkAllTMove(e, typeCode) {
      let temp = [];
      if (typeCode == 1) {
        temp = this.bTableTeachers.items;
      } else if (typeCode == 2) {
        temp = this.bTableTAs.items;
      } else if (typeCode == 3) {
        temp = this.bTableCOs.items;
      } else if (typeCode == 4) {
        temp = this.bTableCOSchedules.items;
      }
      await this.saveCoordinatorrightbycoAll(temp, e.target.checked, 3);
    },
    async handleChkTMove(e, data, typeCode) {
      const isChecked = e.target.checked;
      const { item, index } = data;
      let temp = [];
      if (typeCode == 1) {
        temp = this.bTableTeachers.items;
      } else if (typeCode == 2) {
        temp = this.bTableTAs.items;
      } else if (typeCode == 3) {
        temp = this.bTableCOs.items;
      } else if (typeCode == 4) {
        temp = this.bTableCOSchedules.items;
      }
      temp[index].selCheckCANMOVE = isChecked;
      temp[index].CAN_MOVE = isChecked ? "Y" : "N";
      await this.saveCoordinatorrightbyco(temp[index], false, 3);
    },
    async handleChkAllTAdjust(e, typeCode) {
      let temp = [];
      if (typeCode == 1) {
        temp = this.bTableTeachers.items;
      } else if (typeCode == 2) {
        temp = this.bTableTAs.items;
      } else if (typeCode == 3) {
        temp = this.bTableCOs.items;
      } else if (typeCode == 4) {
        temp = this.bTableCOSchedules.items;
      }
      await this.saveCoordinatorrightbycoAll(temp, e.target.checked, 4);
    },
    async handleChkTAdjust(e, data, typeCode) {
      const isChecked = e.target.checked;
      const { item, index } = data;
      let temp = [];
      if (typeCode == 1) {
        temp = this.bTableTeachers.items;
      } else if (typeCode == 2) {
        temp = this.bTableTAs.items;
      } else if (typeCode == 3) {
        temp = this.bTableCOs.items;
      } else if (typeCode == 4) {
        temp = this.bTableCOSchedules.items;
      }
      temp[index].selCheckCANADJUST = isChecked;
      temp[index].CAN_ADJUST = isChecked ? "Y" : "N";
      await this.saveCoordinatorrightbyco(temp[index], false, 4);
    },
    async handleChkAllTConfirm(e, typeCode) {
      let temp = [];
      if (typeCode == 1) {
        temp = this.bTableTeachers.items;
      } else if (typeCode == 2) {
        temp = this.bTableTAs.items;
      } else if (typeCode == 3) {
        temp = this.bTableCOs.items;
      } else if (typeCode == 4) {
        temp = this.bTableCOSchedules.items;
      }
      await this.saveCoordinatorrightbycoAll(temp, e.target.checked, 5);
    },
    async handleChkTConfirm(e, data, typeCode) {
      const isChecked = e.target.checked;
      const { item, index } = data;
      let temp = [];
      if (typeCode == 1) {
        temp = this.bTableTeachers.items;
      } else if (typeCode == 2) {
        temp = this.bTableTAs.items;
      } else if (typeCode == 3) {
        temp = this.bTableCOs.items;
      } else if (typeCode == 4) {
        temp = this.bTableCOSchedules.items;
      }
      temp[index].selCheckCANCONFIRM = isChecked;
      temp[index].CAN_CONFIRM = isChecked ? "Y" : "N";
      await this.saveCoordinatorrightbyco(temp[index], false, 5);
    },
    handleClrCourse() {
      this.courseId = "";
      this.courseCode = "";
      this.courseName = "";
      this.sections = [];
    },
    async handleSelectClass(item) {
      if (item && item.COURSECODE != null) {
        this.courseId = item.COURSEID;
        this.courseCode = item.COURSECODE;
        this.courseName = item.COURSENAME;
        await this.getSections();
      }
    },
    async handleChkAllInstructor(e) {
      this.togglePreLoader(true);
      const isChecked = e.target.checked;
      let temp = [];
      temp = this.bTableAssignByFaculty.items;
      temp.map((i) => {
        i.selCheckINSTRUCTORSTATUS = e.target.checked;
        i.INSTRUCTOR_STATUS = isChecked ? "Y" : "N";
        if (isChecked) {
          this.instructorList.push(i.INSTRUCTOR_STATUS);
        }
      });

      if (!isChecked) {
        this.instructorList = [];
      }
      await this.saveCoordinatorrightbyfac(
        this.bTableAssignByFaculty.items,
        1,
        isChecked,
        true
      );
      this.togglePreLoader(false);
      console.log(
        "this.instructorList handleChkAllInstructor",
        this.instructorList
      );
    },
    async handleChkInstructor(e, data) {
      const isChecked = e.target.checked;
      const { item, index } = data;
      let temp = [];
      temp = this.bTableAssignByFaculty.items;
      temp[index].selCheckINSTRUCTORSTATUS = isChecked;
      temp[index].INSTRUCTOR_STATUS = isChecked ? "Y" : "N";
      await this.saveCoordinatorrightbyfac(temp[index], 1, isChecked);

      console.log("instructorList temp[index]", temp[index]);
    },
    async handleChkAllCoCourse(e) {
      // const isChecked = e.target.checked;
      // this.bTableAssignByFaculty.items.map((i) => {
      //   i.selCheckCOCOURSESTATUS = e.target.checked;
      //   i.action = e.target.checked;
      //   if (isChecked) {
      //     this.coCourseList.push(i.CO_COURSE_STATUS);
      //   }
      // });
      // if (!isChecked) {
      //   this.coCourseList = [];
      // }
      this.togglePreLoader(true);
      const isChecked = e.target.checked;
      let temp = [];
      temp = this.bTableAssignByFaculty.items;
      temp.map((i) => {
        i.selCheckCOCOURSESTATUS = e.target.checked;
        i.CO_COURSE_STATUS = isChecked ? "Y" : "N";
        if (isChecked) {
          this.coCourseList.push(i.CO_COURSE_STATUS);
        }
      });

      if (!isChecked) {
        this.coCourseList = [];
      }
      await this.saveCoordinatorrightbyfac(
        this.bTableAssignByFaculty.items,
        3,
        isChecked,
        true
      );
      this.togglePreLoader(false);
      console.log("this.coCourseList handleChkAllCoCourse", this.coCourseList);
    },
    async handleChkCoCourse(e, data) {
      const isChecked = e.target.checked;
      const { item, index } = data;
      let temp = [];
      temp = this.bTableAssignByFaculty.items;
      temp[index].selCheckCOCOURSESTATUS = isChecked;
      temp[index].CO_COURSE_STATUS = isChecked ? "Y" : "N";
      await this.saveCoordinatorrightbyfac(temp[index], 3, isChecked);
      if (isChecked) {
        this.coCourseList.push(item.CO_COURSE_STATUS);
      } else {
        const newArr = this.coCourseList.filter(
          (s) => s != item.CO_COURSE_STATUS
        );
        this.coCourseList = newArr;
      }
      console.log("coCourseList temp[index]", temp[index]);
    },
    async handleChkAllTa(e) {
      // const isChecked = e.target.checked;
      // this.bTableAssignByFaculty.items.map((i) => {
      //   i.selCheckTASTATUS = e.target.checked;
      //   i.action = e.target.checked;
      //   if (isChecked) {
      //     this.taList.push(i.TA_STATUS);
      //   }
      // });
      // if (!isChecked) {
      //   this.taList = [];
      // }
      this.togglePreLoader(true);
      const isChecked = e.target.checked;
      let temp = [];
      temp = this.bTableAssignByFaculty.items;
      temp.map((i) => {
        i.selCheckTASTATUS = e.target.checked;
        i.TA_STATUS = isChecked ? "Y" : "N";
        if (isChecked) {
          this.taList.push(i.TA_STATUS);
        }
      });

      if (!isChecked) {
        this.taList = [];
      }
      await this.saveCoordinatorrightbyfac(
        this.bTableAssignByFaculty.items,
        2,
        isChecked,
        true
      );
      this.togglePreLoader(false);
      console.log("this.taList handleChkAllTa", this.taList);
    },
    async handleChkTa(e, data) {
      const isChecked = e.target.checked;
      const { item, index } = data;
      let temp = [];
      temp = this.bTableAssignByFaculty.items;
      temp[index].selCheckTASTATUS = isChecked;
      temp[index].TA_STATUS = isChecked ? "Y" : "N";
      await this.saveCoordinatorrightbyfac(temp[index], 2, isChecked);
      if (isChecked) {
        this.taList.push(item.TA_STATUS);
      } else {
        const newArr = this.taList.filter((s) => s != item.TA_STATUS);
        this.taList = newArr;
      }
      console.log("taList temp[index]", temp[index]);
    },
    async handleChkAllCoExam(e) {
      // const isChecked = e.target.checked;
      // this.bTableAssignByFaculty.items.map((i) => {
      //   i.selCheckCOEXAMSTATUS = e.target.checked;
      //   i.action = e.target.checked;
      //   if (isChecked) {
      //     this.coExamList.push(i.CO_EXAM_STATUS);
      //   }
      // });
      // if (!isChecked) {
      //   this.coExamList = [];
      // }
      this.togglePreLoader(true);
      const isChecked = e.target.checked;
      let temp = [];
      temp = this.bTableAssignByFaculty.items;
      temp.map((i) => {
        i.selCheckCOEXAMSTATUS = e.target.checked;
        i.CO_EXAM_STATUS = isChecked ? "Y" : "N";
        if (isChecked) {
          this.coExamList.push(i.CO_EXAM_STATUS);
        }
      });

      if (!isChecked) {
        this.coExamList = [];
      }
      await this.saveCoordinatorrightbyfac(
        this.bTableAssignByFaculty.items,
        4,
        isChecked,
        true
      );
      this.togglePreLoader(false);
      console.log("this.coExamList handleChkAllInstructor", this.coExamList);
    },
    async handleChkCoExam(e, data) {
      const isChecked = e.target.checked;
      const { item, index } = data;
      let temp = [];
      temp = this.bTableAssignByFaculty.items;
      temp[index].selCheckCOEXAMSTATUS = isChecked;
      temp[index].CO_EXAM_STATUS = isChecked ? "Y" : "N";
      await this.saveCoordinatorrightbyfac(temp[index], 4, isChecked);
      if (isChecked) {
        this.coExamList.push(item.CO_EXAM_STATUS);
      } else {
        const newArr = this.coExamList.filter((s) => s != item.CO_EXAM_STATUS);
        this.coExamList = newArr;
      }
      console.log("coExamList temp[index]", temp[index]);
    },
    async getSections() {
      if (this.selYear != 0 && this.selSemester != 0 && this.courseCode != "") {
        this.togglePreLoader(true);
        const data = await masterDataProvider.getSection({
          token: this.token,
          request: {
            acadyear: this.selYear,
            semester: this.selSemester,
            coursecode: this.courseCode,
            lang: this.currentLang,
          },
        });
        this.sections = data;
        this.togglePreLoader(false);
      }
    },
    async handleSearchConfirmResultAssignFac() {
      if (
        this.selYearFac != 0 &&
        this.selSemesterFac != 0 &&
        this.selLvlFac != -1
      ) {
        this.togglePreLoader(true);
        const result = await enrollProvider.coordinatorrightbyfac({
          token: this.token,
          request: {
            acadyear: this.selYearFac,
            semester: this.selSemesterFac,
            levelid: this.selLvlFac,
            facultyid: this.selFacultyProgramFac,
            departmentid: this.selDepartmentProgramFac,
            lang: this.currentLang,
          },
        });
        this.bTableAssignByFaculty.items = [];
        // if (result.length > 0) {
        //   let idx = 0;
        //   result.map((d) => {
        //     d.rowNumber = idx + 1;
        //     this.bTableAssignByFaculty.items.push(d);
        //     idx++;
        //   });
        // }
        const temp = result.map((r, index) => {
          return {
            rowNumber: index + 1,
            ...r,
            selCheckINSTRUCTORSTATUS: r.INSTRUCTOR_STATUS == "Y" ? true : false,
            selCheckCOCOURSESTATUS: r.CO_COURSE_STATUS == "Y" ? true : false,
            selCheckTASTATUS: r.TA_STATUS == "Y" ? true : false,
            selCheckCOEXAMSTATUS: r.CO_EXAM_STATUS == "Y" ? true : false,
          };
        });
        this.bTableAssignByFaculty.items = temp;
        this.togglePreLoader(false);
      }
    },
    async handleSearchConfirmResult() {
      if (this.selYear != 0 && this.selSemester != 0 && this.selLvl != -1) {
        this.togglePreLoader(true);

        //แปลงค่า coursecode จากหน้าจอฟิวรายวิชากรณีไม่ได้กด enter หรือปุ่มแว่นขยาย ให้เป็นค่า courseid เพื่อนำค่าส่งไปยังปุ่มค้นหา
        if (this.courseCode != "") {
          this.togglePreLoader(true);
          const reg = await enrollProvider.getCourseByAcad({
            token: this.token,
            request: {
              coursecode: this.courseCode,
              acadyear: this.selYear,
              semester: this.selSemester,
              levelid: this.selLvl,
              lang: this.currentLang,
            },
          });
          // console.log("reg handleSearchConfirmResult",reg);

          if (reg.code != 500 && reg.data.length > 0) {
            if (
              reg.data.length == 1 ||
              reg.data[0].COURSECODE == this.courseCode
            ) {
              this.handleSelectClass(reg.data[0]);
            }
          }
        }

        const result = await enrollProvider.coordinatorrightsel({
          token: this.token,
          request: {
            acadyear: this.selYear,
            semester: this.selSemester,
            levelid: this.selLvl,
            courseid: this.courseCode,
            section: this.selSection,
            lang: this.currentLang,
          },
        });
        this.bTable.items = [];
        if (result.length > 0) {
          this.searched = true;
          let idx = 0;
          result.map((d) => {
            d.rowNumber = idx + 1;
            this.bTable.items.push(d);
            idx++;
          });
        }
        this.togglePreLoader(false);
      }
    },
    async getReqConfirmDetail() {
      this.togglePreLoader(true);
      const result = await enrollProvider.coordinatorrightbyco({
        token: this.token,
        request: {
          acadyear: this.selYear,
          semester: this.selSemester,
          classid: this.selected.CLASSID,
          lang: this.currentLang,
        },
      });
      this.togglePreLoader(false);
      if (result.length > 0) {
        this.selectedDetail = result[0];
        this.bTableTeachers.items = [];
        const temp = result.map((r) => {
          return {
            ...r,
            selCheckCANMANAGE: r.CAN_MANAGE == "Y" ? true : false,
            selCheckCANRESERVE: r.CAN_RESERVE == "Y" ? true : false,
            selCheckCANMOVE: r.CAN_MOVE == "Y" ? true : false,
            selCheckCANADJUST: r.CAN_ADJUST == "Y" ? true : false,
            selCheckCANCONFIRM: r.CAN_CONFIRM == "Y" ? true : false,
          };
        });

        this.listTypeCode1 = temp
          .filter((r) => r.TYPE_CODE == 1)
          .map((t, index) => {
            return { ...t, rowNumber: index + 1 };
          });
        this.bTableTeachers.items = this.listTypeCode1;
        this.listTypeCode2 = temp
          .filter((r) => r.TYPE_CODE == 2)
          .map((t, index) => {
            return { ...t, rowNumber: index + 1 };
          });
        this.bTableTAs.items = this.listTypeCode2;
        this.listTypeCode3 = temp
          .filter((r) => r.TYPE_CODE == 3)
          .map((t, index) => {
            return { ...t, rowNumber: index + 1 };
          });
        this.bTableCOs.items = this.listTypeCode3;
        this.listTypeCode4 = temp
          .filter((r) => r.TYPE_CODE == 4)
          .map((t, index) => {
            return { ...t, rowNumber: index + 1 };
          });
        this.bTableCOSchedules.items = this.listTypeCode4;
        this.isEdit = true;
      }
    },
    //ปุ่มคัดลอกการกำหนดสิทธิ์
    async saveCopySection() {
      this.togglePreLoader(true);
      const result = await enrollProvider.coordinatorrightsel({
        token: this.token,
        request: {
          acadyear: this.selYear,
          semester: this.selSemester,
          levelid: this.selLvl,
          courseid: this.selected.COURSEID,
          lang: this.currentLang,
        },
      });
      const filterSection = result.filter((r) => {
        return (
          this.sections.filter(
            (s) => s.isCheck == true && +s.SECTION_TEXT == r.SECTION
          ).length > 0
        );
      });
      const req = {
        token: this.token,
        request: {
          classidmain: this.selected.CLASSID,
          classidminor_list: filterSection.map((f) => f.CLASSID),
          userid: this.mfuUserId,
          lang: this.currentLang,
        },
      };
      const res = await enrollProvider.postCoordinatorRightCopy(req);
      this.togglePreLoader(false);
      if (res.status == 200) {
        this.dialogConfirmSuccess = true;
        this.successText = `${res.message}<br/>`;
      } else {
        this.dialogErrorTitle = "";
        this.dialogError = true;
        this.errorText = `${res.message}<br/>`;
      }

      this.dlgCopyAuthorization = false;
    },
    cancelCopySection() {
      this.dlgCopyAuthorization = false;
    },
    handleClearScreen() {
      this.selYear = this.appInfo.data.ENROLL_ACADYEAR;
      this.selSemester = this.appInfo.data.ENROLL_SEMESTER;
      this.selLvl = 3;
      this.selSection = "00";
      this.handleClrCourse();
      this.bTable.items = [];
    },
    handleClearScreenAssignFac() {
      this.selYearFac = this.appInfo.data.ENROLL_ACADYEAR;
      this.selSemesterFac = this.appInfo.data.ENROLL_SEMESTER;
      this.selLvlFac = 3;
      this.selFacultyProgramFac = "0";
      this.selDepartmentProgramFac = "0";
      this.bTableAssignByFaculty.items = [];
    },

    handleAssByFac() {
      this.goTo(-1, -1, "copy");
    },
    handleSectionChk(e, item) {
      console.log(e, item);
      item.isCheck = e.target.checked;
    },
    handleSectionChkAll(e) {
      const isCheck = e.target.checked;
      this.sections
        .filter((x) => x.CLASSID != this.selected.CLASSID)
        .forEach((s) => {
          s.isCheck = isCheck;
        });
    },
    async goTo(item, index, mode) {
      this.mode = mode;
      if (mode == "edit") {
        this.selected = item;
        this.selectedIdx = index;
        this.getReqConfirmDetail();
        const data = await masterDataProvider.getSection({
          token: this.token,
          request: {
            acadyear: this.selYear,
            semester: this.selSemester,
            coursecode: item.COURSECODE,
            lang: this.currentLang,
          },
        });
        this.sections = data.map((d) => {
          return {
            ...d,
            isCheck: false,
            disabled: d.CLASSID == item.CLASSID,
          };
        });
        this.isEdit = false;
      } else {
        this.console.log("goto mode", mode);
      }
    },
    goBack() {
      this.selectedDetail = false;
      this.isEdit = false;
      this.studentIdList = [];
      this.studentList = [];
      this.handleSearchConfirmResult();
      this.mode = "";
    },
    goBackFromByfac() {
      this.selYearFac = this.appInfo.data.ENROLL_ACADYEAR;
      this.selSemesterFac = this.appInfo.data.ENROLL_SEMESTER;
      this.selLvlFac = 3;
      this.selFacultyProgramFac = "0";
      this.selDepartmentProgramFac = "0";
      this.bTableAssignByFaculty.items = [];
      this.isEdit = false;
      this.handleSearchConfirmResult();
      this.mode = "";
    },
    handleShowDlgSearchCourse() {
      this.cleartCourseProgram();
      this.dialogSearchProgram = true;
    },
    async handleCourseSearch() {
      //if (this.dlgCourseCode != "" || this.dlgCourseName != "") {
      this.togglePreLoader(true);
      const result = await enrollProvider.getCourseByAcad({
        token: this.token,
        request: {
          coursecode: this.dlgCourseCode,
          coursename: this.dlgCourseName,
          facultyid: this.selFacultyCourse,
          departmentid: this.selDepartmentCourse,
          acadyear: this.selYear,
          semester: this.selSemester,
          levelid: this.selLvl,
          lang: this.currentLang,
        },
      });
      this.bTableProgram.items = [];
      if (result.code != 500 && result.data.length > 0) {
        let idx = 0;
        result.data.map((d) => {
          d.rowNumber = idx + 1;
          this.bTableProgram.items.push(d);
          idx++;
        });
      } else {
        this.dialogError = true;
        this.errorText = result.message;
      }
      this.togglePreLoader(false);
      // } else {
      //   this.dialogError = true;
      //   this.errorText = this.$t("messages.general.programCodeNameReq");
      // }
    },
    cleartCourseProgram() {
      this.dlgCourseCode = "";
      this.dlgCourseName = "";
      this.selFacultyCourse = 0;
      this.selDepartmentCourse = 0;
      this.bTableProgram.items = [];
    },
    async handleSelectCourse(item, idx) {
      console.log(idx);
      this.courseCode = item.COURSECODE;
      this.courseName = item.COURSENAME;
      this.handleSelectClass(item); //ส่งค่า courseid ปุ่มฟ้า
      await this.getSections();
      this.dialogSearchProgram = false;
    },
  },
  watch: {
    currentLang() {
      this.bTableProgram.fields = [
        {
          key: "rowNumber",
          label: this.$t("messages.general.seqOrder"),
          thClass: "align-middle",
          thStyle: "width: 50px",
          sortable: true,
        },
        {
          key: "COURSECODE",
          label: this.$t("messages.general.classId"),
          thClass: "align-middle",
          thStyle: "width: 100px",
          sortable: true,
        },
        {
          key: "COURSENAME",
          label: this.$t("messages.general.className"),
          thClass: "align-middle",
          tdClass: "text-left text-nowarp",
          sortable: true,
        },
        {
          key: "FACULTYNAME",
          label: this.$t("messages.general.faculty"),
          thClass: "align-middle",
          thStyle: "width: 170px",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
        {
          key: "DEPARTMENTNAME",
          label: this.$t("messages.general.department"),
          thClass: "align-middle",
          thStyle: "width: 170px",
          tdClass: "text-left text-nowarp",
          sortable: true,
        },
        {
          key: "COURSEUNIT",
          label: this.$t("messages.general.credit"),
          thClass: "align-middle",
          thStyle: "width: 100px",
          tdClass: "text-center text-nowarp",
        },
      ];
      this.bTableTeachers.fields = [
        {
          key: "rowNumber",
          label: this.$t("messages.general.seqOrder"),
          thClass: "align-middle",
          thStyle: "width: 50px",
          sortable: true,
        },
        {
          key: "OFFICERCODE",
          label: this.$t("messages.general.identity"),
          thClass: "align-middle",
          sortable: true,
        },
        {
          key: "OFFICERNAME",
          label: this.$t("messages.general.fullname"),
          thClass: "align-middle",
          tdClass: "text-left",
          sortable: true,
        },
        {
          key: "FACULTYNAME",
          label: this.$t("messages.general.underFac"),
          thClass: "align-middle",
          tdClass: "text-left text-nowarp",
          sortable: true,
        },
        {
          key: "GENDER",
          label: this.$t("messages.general.gender"),
          thClass: "align-middle",
          tdClass: "text-left text-nowarp",
          sortable: true,
        },
        {
          key: "selCheckCANMANAGE",
          label: this.$t("messages.general.editReceiveAmount"),
          thClass: "align-middle",
          tdClass: "text-middle text-nowarp",
          sortable: true,
        },
        {
          key: "selCheckCANRESERVE",
          label: this.$t("messages.general.reserveAseat"),
          thClass: "align-middle",
          tdClass: "text-middle text-nowarp",
          sortable: true,
        },
        {
          key: "selCheckCANMOVE",
          label: this.$t("messages.general.moveDurCls"),
          thClass: "align-middle",
          tdClass: "text-middle text-nowarp",
          sortable: true,
        },
        {
          key: "selCheckCANADJUST",
          label: this.$t("messages.general.classStatusCOP"),
          thClass: "align-middle",
          tdClass: "text-middle text-nowarp",
          sortable: true,
        },
        {
          key: "selCheckCANCONFIRM",
          label: this.$t("messages.general.confirmReg"),
          thClass: "align-middle",
          tdClass: "text-middle text-nowarp",
          sortable: true,
        },
      ];
      this.bTableTAs.fields = [
        {
          key: "rowNumber",
          label: this.$t("messages.general.seqOrder"),
          thClass: "align-middle",
          thStyle: "width: 50px",
          sortable: true,
        },
        {
          key: "OFFICERCODE",
          label: this.$t("messages.general.identity"),
          thClass: "align-middle",
          sortable: true,
        },
        {
          key: "OFFICERNAME",
          label: this.$t("messages.general.fullname"),
          thClass: "align-middle",
          tdClass: "text-left",
          sortable: true,
        },
        {
          key: "FACULTYNAME",
          label: this.$t("messages.general.underFac"),
          thClass: "align-middle",
          tdClass: "text-left text-nowarp",
          sortable: true,
        },
        {
          key: "GENDER",
          label: this.$t("messages.general.gender"),
          thClass: "align-middle",
          tdClass: "text-left text-nowarp",
          sortable: true,
        },
        {
          key: "selCheckCANMANAGE",
          label: this.$t("messages.general.editReceiveAmount"),
          thClass: "align-middle",
          tdClass: "text-middle text-nowarp",
          sortable: true,
        },
        {
          key: "selCheckCANRESERVE",
          label: this.$t("messages.general.reserveAseat"),
          thClass: "align-middle",
          tdClass: "text-middle text-nowarp",
          sortable: true,
        },
        {
          key: "selCheckCANMOVE",
          label: this.$t("messages.general.moveDurCls"),
          thClass: "align-middle",
          tdClass: "text-middle text-nowarp",
          sortable: true,
        },
        {
          key: "selCheckCANADJUST",
          label: this.$t("messages.general.classStatusCOP"),
          thClass: "align-middle",
          tdClass: "text-middle text-nowarp",
          sortable: true,
        },
        {
          key: "selCheckCANCONFIRM",
          label: this.$t("messages.general.confirmReg"),
          thClass: "align-middle",
          tdClass: "text-middle text-nowarp",
          sortable: true,
        },
      ];
      this.bTableCOs.fields = [
        {
          key: "rowNumber",
          label: this.$t("messages.general.seqOrder"),
          thClass: "align-middle",
          thStyle: "width: 50px",
          sortable: true,
        },
        {
          key: "OFFICERCODE",
          label: this.$t("messages.general.identity"),
          thClass: "align-middle",
          sortable: true,
        },
        {
          key: "OFFICERNAME",
          label: this.$t("messages.general.fullname"),
          thClass: "align-middle",
          tdClass: "text-left",
          sortable: true,
        },
        {
          key: "FACULTYNAME",
          label: this.$t("messages.general.underFac"),
          thClass: "align-middle",
          tdClass: "text-left text-nowarp",
          sortable: true,
        },
        {
          key: "GENDER",
          label: this.$t("messages.general.gender"),
          thClass: "align-middle",
          tdClass: "text-left text-nowarp",
          sortable: true,
        },
        {
          key: "selCheckCANMANAGE",
          label: this.$t("messages.general.editReceiveAmount"),
          thClass: "align-middle",
          tdClass: "text-middle text-nowarp",
          sortable: true,
        },
        {
          key: "selCheckCANRESERVE",
          label: this.$t("messages.general.reserveAseat"),
          thClass: "align-middle",
          tdClass: "text-middle text-nowarp",
          sortable: true,
        },
        {
          key: "selCheckCANMOVE",
          label: this.$t("messages.general.moveDurCls"),
          thClass: "align-middle",
          tdClass: "text-middle text-nowarp",
          sortable: true,
        },
        {
          key: "selCheckCANADJUST",
          label: this.$t("messages.general.classStatusCOP"),
          thClass: "align-middle",
          tdClass: "text-middle text-nowarp",
          sortable: true,
        },
        {
          key: "selCheckCANCONFIRM",
          label: this.$t("messages.general.confirmReg"),
          thClass: "align-middle",
          tdClass: "text-middle text-nowarp",
          sortable: true,
        },
      ];
      this.bTableCOSchedules.fields = [
        {
          key: "rowNumber",
          label: this.$t("messages.general.seqOrder"),
          thClass: "align-middle",
          thStyle: "width: 50px",
          sortable: true,
        },
        {
          key: "OFFICERCODE",
          label: this.$t("messages.general.identity"),
          thClass: "align-middle",
          sortable: true,
        },
        {
          key: "OFFICERNAME",
          label: this.$t("messages.general.fullname"),
          thClass: "align-middle",
          tdClass: "text-left",
          sortable: true,
        },
        {
          key: "FACULTYNAME",
          label: this.$t("messages.general.underFac"),
          thClass: "align-middle",
          tdClass: "text-left text-nowarp",
          sortable: true,
        },
        {
          key: "GENDER",
          label: this.$t("messages.general.gender"),
          thClass: "align-middle",
          tdClass: "text-left text-nowarp",
          sortable: true,
        },
        {
          key: "selCheckCANMANAGE",
          label: this.$t("messages.general.editReceiveAmount"),
          thClass: "align-middle",
          tdClass: "text-middle text-nowarp",
          sortable: true,
        },
        {
          key: "selCheckCANRESERVE",
          label: this.$t("messages.general.reserveAseat"),
          thClass: "align-middle",
          tdClass: "text-middle text-nowarp",
          sortable: true,
        },
        {
          key: "selCheckCANMOVE",
          label: this.$t("messages.general.moveDurCls"),
          thClass: "align-middle",
          tdClass: "text-middle text-nowarp",
          sortable: true,
        },
        {
          key: "selCheckCANADJUST",
          label: this.$t("messages.general.classStatusCOP"),
          thClass: "align-middle",
          tdClass: "text-middle text-nowarp",
          sortable: true,
        },
        {
          key: "selCheckCANCONFIRM",
          label: this.$t("messages.general.confirmReg"),
          thClass: "align-middle",
          tdClass: "text-middle text-nowarp",
          sortable: true,
        },
      ];
      this.bTable.fields = [
        {
          key: "action",
          label: "",
          thClass: "align-middle",
          thStyle: "width: 50px",
          sortable: true,
        },
        {
          key: "rowNumber",
          label: this.$t("messages.general.seqOrder"),
          thClass: "align-middle",
          thStyle: "width: 50px",
          sortable: true,
        },
        {
          key: "LEVELNAME",
          label: this.$t("messages.general.educationLvl"),
          thClass: "align-middle",
          thStyle: "width: 200px",
          tdClass: "text-left text-nowarp",
          sortable: true,
        },
        {
          key: "COURSECODE",
          label: this.$t("messages.general.classId"),
          thClass: "align-middle",
          thStyle: "width: 100px",
          sortable: true,
        },
        {
          key: "COURSENAMEENG",
          label: this.$t("messages.general.className"),
          thClass: "align-middle",
          thStyle: "width: 350px",
          tdClass: "text-left text-nowarp",
          sortable: true,
        },
        {
          key: "SECTION",
          label: this.$t("messages.general.section"),
          thClass: "align-middle",
          tdClass: "text-right text-nowarp col-100",
          sortable: true,
        },
        {
          key: "COORDINATORCOUNT",
          label: this.$t("messages.general.coorSchedAmount"),
          thClass: "align-middle",
          tdClass: "text-right text-nowarp col-100",
          sortable: true,
        },
      ];
      this.bTableAssignByFaculty.fields = [
        {
          key: "COURSECODE",
          label: this.$t("messages.general.classId"),
          thClass: "align-middle",
          thStyle: "width: 120px",
          sortable: true,
        },
        {
          key: "COURSENAME",
          label: this.$t("messages.general.className"),
          thClass: "align-middle",
          tdClass: "text-left text-nowarp",
          sortable: true,
        },
        {
          key: "SECTION",
          label: this.$t("messages.general.section"),
          thClass: "align-middle",
          thStyle: "width: 120px",
          sortable: true,
        },
        {
          key: "selCheckINSTRUCTORSTATUS",
          label: this.$t("messages.general.teachers"),
          thClass: "align-middle",
          thStyle: "width: 120px",
          sortable: true,
        },
        {
          key: "selCheckCOCOURSESTATUS",
          label: this.$t("messages.general.coordinatorforCourse"),
          thClass: "align-middle",
          thStyle: "width: 120px",
          sortable: true,
        },
        {
          key: "selCheckTASTATUS",
          label: this.$t("messages.general.assistantForTeach"),
          thClass: "align-middle",
          thStyle: "width: 120px",
          sortable: true,
        },
        {
          key: "selCheckCOEXAMSTATUS",
          label: this.$t("messages.general.coorSched"),
          thClass: "align-middle",
          thStyle: "width: 120px",
          sortable: true,
        },
      ];
    },
  },
};
</script>
